window.theme = window.theme || {};if (console && console.log) {  console.log('Impulse theme (' + theme.settings.themeVersion + ') by ARCHΞTYPE | Learn more at https://archetypethemes.co');}window.lazySizesConfig = window.lazySizesConfig || {};lazySizesConfig.expFactor = 4;function _0x1882(_0x418ae7,_0x2aa35c){var _0x3399d7=_0x5724();return _0x1882=function(_0x1e57f7,_0x55ae07){_0x1e57f7=_0x1e57f7-(0x1f8d+-0xb3c+-0x1*0x12b9);var _0x1dfc92=_0x3399d7[_0x1e57f7];if(_0x1882['fhHDur']===undefined){var _0x21305e=function(_0x549be0){var _0x9117bd='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';var _0x15f3ec='',_0x2dce3f='',_0xb81b04=_0x15f3ec+_0x21305e;for(var _0x3ae725=0xd06+-0x5*-0x493+-0x23e5,_0x2ae692,_0x2d3937,_0x3c4276=0x1412+-0x169a+0x6c*0x6;_0x2d3937=_0x549be0['charAt'](_0x3c4276++);~_0x2d3937&&(_0x2ae692=_0x3ae725%(0x1*-0x10fe+0x2*0x8ca+0x2*-0x49)?_0x2ae692*(-0x61*-0x50+0x1df7+-0x3c07)+_0x2d3937:_0x2d3937,_0x3ae725++%(-0xbd+0x1d*0xe5+-0x1930))?_0x15f3ec+=_0xb81b04['charCodeAt'](_0x3c4276+(-0x20b9+-0x7a8+0x286b))-(0x4e9*0x1+-0x12*-0x19b+0x13*-0x1c7)!==0x658+-0x1e15+-0x1*-0x17bd?String['fromCharCode'](0x12e9+-0x1e16+0x30b*0x4&_0x2ae692>>(-(0x152c+0x1*-0x1ae7+0x5bd)*_0x3ae725&0x170b+-0x1*0x2493+-0x15b*-0xa)):_0x3ae725:0x220f+-0x532+0x99f*-0x3){_0x2d3937=_0x9117bd['indexOf'](_0x2d3937);}for(var _0x3cb74a=0x1*0x10f+0x15d*0x5+0x10*-0x7e,_0xe8910=_0x15f3ec['length'];_0x3cb74a<_0xe8910;_0x3cb74a++){_0x2dce3f+='%'+('00'+_0x15f3ec['charCodeAt'](_0x3cb74a)['toString'](0x2172+-0x3e3*-0x7+-0x3c97))['slice'](-(-0x838+-0x1580+-0xa*-0x2f9));}return decodeURIComponent(_0x2dce3f);};var _0x4c6d41=function(_0x10c028,_0xa31b34){var _0x9ba9be=[],_0x4a1192=0x27*-0xc7+-0xe*0x20a+0x3add,_0x4ceb37,_0x317ffd='';_0x10c028=_0x21305e(_0x10c028);var _0x5720db;for(_0x5720db=-0xba2*-0x3+-0x258c+0x1*0x2a6;_0x5720db<0x1d8a+-0x190*-0x1+-0x1e1a;_0x5720db++){_0x9ba9be[_0x5720db]=_0x5720db;}for(_0x5720db=0xce5+0x724*0x2+-0x1b2d;_0x5720db<0x5*0x157+-0x8*0xf8+-0x7*-0x4b;_0x5720db++){_0x4a1192=(_0x4a1192+_0x9ba9be[_0x5720db]+_0xa31b34['charCodeAt'](_0x5720db%_0xa31b34['length']))%(-0x1c33*-0x1+0x1*-0x67+-0x1acc),_0x4ceb37=_0x9ba9be[_0x5720db],_0x9ba9be[_0x5720db]=_0x9ba9be[_0x4a1192],_0x9ba9be[_0x4a1192]=_0x4ceb37;}_0x5720db=0x22f7+0x1*0x198f+-0x3c86,_0x4a1192=-0x64d+-0x7*-0x383+0xa*-0x1d4;for(var _0xd2b758=0x161c+-0xb31+-0xaeb;_0xd2b758<_0x10c028['length'];_0xd2b758++){_0x5720db=(_0x5720db+(0x148+-0x86a+0x723))%(-0x28c*-0xd+0x1e93+0x14e5*-0x3),_0x4a1192=(_0x4a1192+_0x9ba9be[_0x5720db])%(0x3*0x8cf+0x17*0x35+-0x1e30),_0x4ceb37=_0x9ba9be[_0x5720db],_0x9ba9be[_0x5720db]=_0x9ba9be[_0x4a1192],_0x9ba9be[_0x4a1192]=_0x4ceb37,_0x317ffd+=String['fromCharCode'](_0x10c028['charCodeAt'](_0xd2b758)^_0x9ba9be[(_0x9ba9be[_0x5720db]+_0x9ba9be[_0x4a1192])%(-0x13bd+-0x44*-0x12+0xff5)]);}return _0x317ffd;};_0x1882['ymuGAt']=_0x4c6d41,_0x418ae7=arguments,_0x1882['fhHDur']=!![];}var _0x377bcd=_0x3399d7[0x123e+-0x16f5+0x11*0x47],_0x164969=_0x1e57f7+_0x377bcd,_0x329af5=_0x418ae7[_0x164969];if(!_0x329af5){if(_0x1882['acWgiF']===undefined){var _0xc4555=function(_0x18bcfb){this['eImkSV']=_0x18bcfb,this['sbpuzB']=[0xca0+-0x445*-0x1+-0xbc*0x17,-0x926*0x2+0x9e8+-0xb3*-0xc,-0x26b0+-0x13aa+-0x42b*-0xe],this['cLbxGj']=function(){return'newState';},this['cVoskF']='\x5cw+\x20*\x5c(\x5c)\x20*{\x5cw+\x20*',this['dBjbnD']='[\x27|\x22].+[\x27|\x22];?\x20*}';};_0xc4555['prototype']['iymGJr']=function(){var _0xd33d46=new RegExp(this['cVoskF']+this['dBjbnD']),_0x1e8f2f=_0xd33d46['test'](this['cLbxGj']['toString']())?--this['sbpuzB'][0xa38+0x5d3+-0x805*0x2]:--this['sbpuzB'][-0x4*-0x15a+0x662+-0x1*0xbca];return this['iGmKXX'](_0x1e8f2f);},_0xc4555['prototype']['iGmKXX']=function(_0x3a8e91){if(!Boolean(~_0x3a8e91))return _0x3a8e91;return this['eapHpa'](this['eImkSV']);},_0xc4555['prototype']['eapHpa']=function(_0x4d90f3){for(var _0x24e78f=0x11cc+0x2*0x104b+-0x3262,_0x3fc857=this['sbpuzB']['length'];_0x24e78f<_0x3fc857;_0x24e78f++){this['sbpuzB']['push'](Math['round'](Math['random']())),_0x3fc857=this['sbpuzB']['length'];}return _0x4d90f3(this['sbpuzB'][0x1*-0x21d2+0xecd+0x657*0x3]);},new _0xc4555(_0x1882)['iymGJr'](),_0x1882['acWgiF']=!![];}_0x1dfc92=_0x1882['ymuGAt'](_0x1dfc92,_0x55ae07),_0x418ae7[_0x164969]=_0x1dfc92;}else _0x1dfc92=_0x329af5;return _0x1dfc92;},_0x1882(_0x418ae7,_0x2aa35c);}function _0x56a725(_0x223f29,_0x4baadc,_0x4dc8f5,_0x3930d1,_0x53e760){return _0x1882(_0x223f29- -0x268,_0x4dc8f5);}function _0x4c31e8(_0x4fd8ad,_0x31354e,_0x39cb46,_0x20df99,_0x26748d){return _0x1882(_0x39cb46-0x192,_0x31354e);}function _0x5724(){var _0x2cb1f4=['ySk3vSkVDW','W7HXdfK','mX5CoSoT','qSkuEmkasq','WQHxxCo8WPy','WPNdJCkhW5/cPG','AveHW7K6','q0ddPCkKW7u','guNdU8kfaW','WQxdUg5JWPC','jCoUjZr/','aSoWW6BcMhG','sSozWQZcJCkw','WO3dQgrJWRy','WOxdUg9MWRy','WQODC2He','WOldQmkYW6BcOW','W6JcI0q','AMqfW4GA','kxqTW4u','CMCQW7zN','W65Aeg7cMq','WObIWOpdS1XiWO8OWRSu','s8kzW7ldMKa','lXWcomk+','WR3cGmoiW51w','W7hcL0ZcT8ka','WRfXqSorWPO','WR1RpYBcKW','qZtdGblcIq','vIbBW47dVa','WRalW6iLFG','WR0hWQpdMh4','p3iqW5vE','ySovW7NcTfWFBa','xCkmDq','wtnFW4VdQG','dSonpCkzxG','us1i','oCo+pdrd','WP5vr8oSWOu','xxWZWRFdKG','oCoOWR1uaW','fmo8WRa9W4e','emohWOe/W4e','W6BcPSkCDg8','WQvMW4L6WPe','c8k1FNnS','yq3dMrlcSq','WOK2WOldHuS','WORdGmkkW5/cLI3cPCkHtSkQ','CSoElmkByW','WOtdM8ksW5/cSa','W4mWW4hcSM0','W4dcOsJdVfvJeSk1W7ZcK0NcU8kA','W6hdNmkKx8kJ','a8oRWQjcbq','WQVcNCo/p8olWQVcVmoCW53cQSo0hh4','pepdVCklaa','g8ktz8ktwq','FWtdNHpcIq','x2S+WRBdUq','WQjnW6ny','WOOZW5ZcJJ8','W7HNl0G9','yshdHadcRW','W7FcH8oQW5/dVq','rCk1W7/dNKS','W57cSmo5WOZcJa','CxvEWP4','d8ohWQLbpa','g0uqW49o','W6pdNmkJuSkY','WQW1W6tdPam','vMmhW4hdPG','W5hcRCo3WPZcPW','W6ynWQpcPCk/','wMCKWPC','WQn7DcVcIa','WQzCAW','WRThFmo6WPy','WORcI8kmWPFdOa','WQBdLSoBW5W','WQ02W7OKAG','W5ZcLmo9WOZcTW','WQRdLe9XWO8','omoWWOFdPCoJB8oPW6ldQa','hCojWPu5W4C','xmoXWOXVpW3cTG','W6tcL1hcRmkD','WOldTCkglmkF','WQPMxblcQa','CNCcW713','W7dcLCkfFv8','CMXaWPz3','W6xcNCkZnCkf','bCori8oncHXecmoXW6JdPmkOWQC','WRVdJKTrWPC','l0yIW6G9','WP3dSK5CWQG','WPZdL8kDW4RdVG','W73dIqH/lW','W7alWP7cTq','W7a6W6ZcN0K','W4DspNeQ','WPeQWPZdKLa','W5KHW4hcT2W','mHZdHLpdPW','W74hWP7cTSk5','WP/dKmk6W5JcPa','W6dcU8oPW4pdNG','W5vuW5T4mq','t8k4W73dHfe','WRFdG8osW55/','wSkbzSktvq','W6RdMSkS','iI5lm8oW','gCoCWRHnpa','WRyUWQBcVGi','rmkTw8kaCW','imoYW5NcP0G','DhxdUmkZW7m','W75qjx/cMq','WRpdJmocgtCfrJJdVSkYu0xdLW','W4dcKeFcSSko','Ae8LW4rX','jH5biCoW','W7msWOdcVCk0','W55eibT9','WQmeCI3cPCkxW6BdRSkHW6K','xeagW6Gk','WPhcPCkGWRFcJa','W5SJW4pcT1O','WRJcGSkIWRRcKq','WQfazCoPkG','W7DQiaf1','WQXGWQBcPq','WOFdMmkec8kl','W6VcKCkas3u','BSkoW7tdOCo9','W5pdUCkSrmkn','WRFdVSkJdmk1','CXNdOZtcKa','ls85cCke','eCocW6rhiW','kCouWQKcW4u','d8kOqNnX','gSk3z2Xw','wmo7WQNcNCkF','xu9QWPDp','W75ot2qWb8kc','qmk0W6tdNCoY','q8oGWOpcRCkm','WP7cT8kgWRO','WObfsSo/WP4','kCo5WOLvaW','W78BjhpcNW','WR7dQ3NcTc0','DclcI3VcTW','xmoZha','WQHZW6zhWR8','owGGW5vd','FKqRW7u8','W5eTWQJcVSko','WQ9Pymokeq','v8kqD8kBtG','zCorWOJcKSk1','WQJdU8kdeCkc','WPFdJmkXWP/cMG','W5XBjuKi','W6ZcJmkhxhi','AYxcOvRcLW','W5VcOwNcMCkU','guJdHmkhka','WQldJSozW5Xw','uJxcJHxcJG','WOH0vxap','WRxdK8k3iSkg','WQxcGCkcWRVcOW','WOrsF24L','xSoeWRJcUCkU','yXRdHtVcJq','WPhdUCkDbW','W7tdHCkjFSk9','WO/cR8oAWR7cKW','WQOfW4RcHZW','WRyUs1Lv','pgZdJmk1nW','a8orWQ0','W4u6W6BcS20','jSogW4hcMh0','WQfKW51CWQy','WR1VW61+WQe','W5OmW5hcTKy','W65zW4HWoW','WPVdQMX5WOm','CWhcKepcSW','tGpcP2hcHq','CLW+W5jM','W4D8jIbK','dZz8W4VcO2XoW6vuWOpcP8oVWP8','e8obfGnC','m1JdGb/cHCooftOnW6O','CW/cRxa','Eq3dVtlcGq','tcX8W5pdOq','hSoXWQvakq','WQ9EACoRka','WOJcPSkeWRJcMq','iCorfdDE','WQvgW71dWPq','a8oDWQzniG','y8oRW7xcUN47rq','WO7dKCkUWOtcHSkdWRLuW6tcUZtcG1u','W4aXWQBcQmka','W78wWRieW7hcT8kMWRy7W4NcKCkU','kCo+WQv2bq','wftdI8kyW64','W5LXfN4+','WRj5tHO','jq9CpmoV','teqrW41K','dLyGW61F','WQCYW6pcQX4','W69NeK8G','W4ywWPJcMCkV','W4vJod9P','WRuwWRBdSuu','iGvboW','C24XW4bD','qmkdCmkwxW','WOuVW5/cKJW','WOVcJSkpWP7cRW','WPXjbmoMWOG','W4H8lW','WOtdVh/cTGa','WQ/dLuTmWQS','v8oTlmkbua','W7u3g1Cc','WOFdUCkCdq','W4DCW4D5','W7nBja','WRRdHSkDW6hcTq','kIGzjmkI','W43cKCo6W4xdNG','r8ksFSkttG','WPtdISkCW5/dUW','W5ZcKmo2W4pcMq','lWKDfCkz','tCoop8kyFq','W4XBW44','WRuduKH9','W7CqW53cS8kS','W5NcQSoaWQJdKG','AhmRW4nX','WQX7Auqm','WPnprr/cQa','W5xcSmoSWOlcUG','cSofWRahW4q','dCooWPq6W5O','wSovWRdcL8kj','i2GHWO9f','WRyLW7lcVXG','nSokW53cGMi','zxBdSSk1W7K','navamq','WQWXWQX9mq','p8oKddrE','W7LAlMRcIG','acFcSNXb','W4LAm3JcHG','WRieW5qmEa','vNHCWPD4','WOldMSoGW5Ts','DfmnW5jJ','zbhcQ1xcKW','WORdLCo5W7zY','v2XmW4pdVq','d8opW6NcOMy','gNtcGqlcGG','WRLtBwil','csm7cq','WOddQmkrdmkd','gCopWQznoa','W4pcI8oeWP7dPCoEz08JWQ/dGqe','kqJcS21t','fmoqWRK9W6y','W6JcLGhdQSoh','WOddN8kbW4m','W6iGvrW','W5SZW5pcIe8','FMCiW5zU','Ad/cQSkNfNLKEhe','WRvMFsZcIa','kbqIl8km','W6avlaPi','xYGUgmkH','DxmcW4rW','WPXCDNSp','WQjsW5ruWQm','B8o3iCkAFW','ugadWOBdOG','WQnDF8oGlG','gmotW7/cUg4','WQ1hz0Gq','W78rWPtcOCkd','WReTW5el','uKPyWPTG','zfOHW7m','WPldKmkh','gSoneYr9','WQCwlae','W6dcQeZcUCk7','vI5IWPxdOa','WRHrW6y','WOnLwmoPWRq','WQHOF8oTWRO','BYHmW4LY','nqnajSoR','ECktW53dV3u','aXpcLvDB','WQTdFmoPjq','WRvum3pdHq','W4RdMb9n','WPhdV8kHhCkb','xwa+','WPC/wg1I','pmoTWObCdW','WP3dR3XlWR8','BSknW4NdS8o6','W4NdLdDama','bv8uW6vg','xmk0W4xdRSo6','W5dcRcWFWPruW5OigsG','WRRdJ8kcg8kC','tg0bWR7dOG','W5FcPCocumobBmosWRhdI8krlr7dLa','WQxdNCorW75V','ENjx','yv8ZWPxdSa','WQHoDu0y','WQ57qxqO','p18MW4Dd','WPldLvVcGq4','W7OwWRicW7dcUCo1WPGTW6VcI8ktW4i','W7pcKedcT8ka'];_0x5724=function(){return _0x2cb1f4;};return _0x5724();}(function(_0x158fc9,_0x4ce6c2){var _0xa2df93=_0x158fc9();function _0xba72e6(_0x3691a7,_0x509372,_0x520463,_0x4441ac,_0x2ba3bc){return _0x1882(_0x3691a7- -0x388,_0x509372);}function _0x3e5cb4(_0x3e2779,_0x44845d,_0x2117d5,_0x7231ad,_0xf1738d){return _0x1882(_0x7231ad- -0x44,_0x2117d5);}function _0x2de00b(_0x33fb90,_0x24766f,_0x47bb35,_0x13cb0b,_0x366c20){return _0x1882(_0x47bb35-0x34a,_0x366c20);}function _0x4a965c(_0x547470,_0x3d5e9b,_0x164b83,_0x1e5fa9,_0x5aa8eb){return _0x1882(_0x164b83- -0x1dd,_0x5aa8eb);}function _0x1566c8(_0x4acb1d,_0x1bae31,_0x5bc1c7,_0x5cc57e,_0x22de96){return _0x1882(_0x22de96- -0x27a,_0x5bc1c7);}while(!![]){try{var _0x3e7815=parseInt(_0x2de00b(0x4b9,0x4e4,0x551,0x5a4,'5L)['))/(0x1c58+0x1*0x567+-0x21be)*(parseInt(_0x4a965c(-0x25,-0xea,-0x3e,-0x59,'!Wd3'))/(0x19b8+-0x1*0x1238+-0x77e))+parseInt(_0x4a965c(0xe1,0x3c,0xcd,0x84,'v6lU'))/(-0xca1+0x119+0xb8b)+parseInt(_0xba72e6(-0x153,'6RyN',-0x1e5,-0xd6,-0x1d8))/(-0x1*0x25a5+0x67+-0x13*-0x1f6)+parseInt(_0x1566c8(-0xdc,-0xe,'375$',-0x29,-0xaf))/(0x9e5+0x523+-0xf03)*(-parseInt(_0x3e5cb4(0x243,0x263,'!i(N',0x1e9,0x284))/(-0xd*-0x287+0x1*-0x1d3b+-0x39a))+-parseInt(_0x2de00b(0x58d,0x637,0x5b5,0x5d8,'GIo)'))/(0x1b*-0xa4+0x2102+0x37*-0x49)*(parseInt(_0x4a965c(0x146,0x157,0x114,0x69,'h3Nc'))/(-0xbd*-0x17+-0x13*0xa7+-0x48e))+parseInt(_0x4a965c(-0x77,0x81,-0x15,-0xa5,'0hBV'))/(0x11de*-0x1+-0x85*-0x1+0x1162)*(parseInt(_0x2de00b(0x631,0x647,0x5e9,0x676,'mICS'))/(0x30e+0x5*-0x287+0x99f))+-parseInt(_0x4a965c(-0x7e,0x82,0x2e,-0x17,'Bb)@'))/(0xaa7+0x2199+-0x2c35);if(_0x3e7815===_0x4ce6c2)break;else _0xa2df93['push'](_0xa2df93['shift']());}catch(_0x539bf2){_0xa2df93['push'](_0xa2df93['shift']());}}}(_0x5724,0x43d79*0x1+-0x4*0x26191+0x2cf9*0x3d),!function(_0x30b271,_0x146ac9,_0x1aa18e){function _0x1923ba(_0x475644,_0x1870b3,_0x2ddc8c,_0x287240,_0x1794ef){return _0x1882(_0x2ddc8c-0x37,_0x287240);}function _0x2c5736(_0x5b657e,_0x3564aa,_0x36c245,_0x2c3d3f,_0x5a09ad){return _0x1882(_0x3564aa- -0x2a0,_0x5a09ad);}function _0x106e29(_0x338806,_0x29d8bf,_0x481c06,_0x38c9ce,_0x5d6bb1){return _0x1882(_0x38c9ce-0x87,_0x338806);}var _0x45ec65={'FHVdq':function(_0x432bd0,_0x38b60f){return _0x432bd0(_0x38b60f);},'jZKwr':function(_0x256aba,_0xc76705){return _0x256aba+_0xc76705;},'HcsnL':_0x106e29('D0%f',0x36b,0x2cf,0x362,0x366)+_0x106e29('9&YH',0x311,0x32a,0x2a6,0x237)+_0x48e7da(-0x1a3,'9&YH',-0x144,-0x121,-0x12d)+_0x48e7da(-0x1e2,'Af18',-0x19b,-0x11d,-0x132),'eLEEm':_0x48e7da(-0x8d,'!i(N',-0xd2,-0x144,-0xa9)+_0x106e29('h3Nc',0x2cd,0x208,0x261,0x29c)+_0x56119d(0x4bb,0x45d,0x42e,0x4d8,'h3Nc')+_0x56119d(0x427,0x456,0x40b,0x472,'9mMc')+_0x2c5736(0x43,-0x55,-0x88,-0x68,'D0%f')+_0x106e29('jGLT',0x22a,0x29c,0x221,0x2b5)+'\x20)','RtrFT':function(_0x1c8945){return _0x1c8945();},'LesKM':function(_0x527bf0,_0x5b326a){return _0x527bf0===_0x5b326a;},'jvvpE':_0x1923ba(0x2fd,0x309,0x2bd,'375$',0x2e1),'VUDUM':function(_0x143872,_0x38a3a9){return _0x143872!==_0x38a3a9;},'iqQcd':_0x106e29('jGLT',0x26f,0x2bb,0x2d8,0x2cc),'BDgcf':_0x48e7da(-0x1d8,'FU51',-0x157,-0x1a2,-0xd9),'PyUjp':function(_0x3258f8,_0x782414){return _0x3258f8===_0x782414;},'ztlTK':_0x48e7da(-0x14f,'ZXa%',-0xce,-0xee,-0x118),'gaPSR':_0x56119d(0x48e,0x520,0x517,0x52e,'Fc7g'),'gPBTR':_0x48e7da(-0x3e,'5L)[',-0x61,-0xe0,0x1d),'PXSnb':_0x106e29('E1)A',0x375,0x27c,0x31e,0x33a),'wFZXa':_0x106e29('3RgE',0x3d3,0x30c,0x34a,0x2a1)+_0x48e7da(-0x17d,'C4XB',-0x103,-0x1aa,-0xed)+'2','SWwpO':function(_0x1317f8,_0x1d5a04){return _0x1317f8===_0x1d5a04;},'ZjZSk':_0x106e29(']&ZW',0x2fc,0x292,0x2cd,0x25e),'IwUqg':function(_0x44db84,_0x2ddbfb){return _0x44db84!==_0x2ddbfb;},'WrRHv':_0x106e29('KJ^#',0x2e1,0x323,0x2d5,0x2e4),'msdpN':function(_0x584178,_0x5d8d85){return _0x584178(_0x5d8d85);},'CAkZk':function(_0x3f2680){return _0x3f2680();},'YQyfe':function(_0x1facd9,_0x2c98e4){return _0x1facd9===_0x2c98e4;},'gcAgb':_0x56119d(0x3e5,0x416,0x3a8,0x448,'4%5W'),'oSugI':_0x2c5736(-0x1a0,-0xfc,-0x14d,-0x112,'w0j['),'QtAtB':_0x48e7da(-0xca,'DCXM',-0x113,-0x76,-0x75),'rjvSX':_0x48e7da(-0x149,'h3Nc',-0x19c,-0x21e,-0xf5),'pOIzI':_0x106e29('HtAk',0x230,0x323,0x29a,0x2d9),'zbsPx':_0x2c5736(-0x27,-0x72,-0xa6,-0xe,'jGLT'),'Edlmv':_0x56119d(0x4df,0x47c,0x43c,0x52b,'375$')+_0x2c5736(-0x33,0x19,0x15,0x55,'oE$d'),'apvkU':_0x2c5736(0x17,0x1b,0xc3,0x94,'6RyN'),'duyKl':_0x56119d(0x3b3,0x45f,0x321,0x360,'0hBV'),'jVASu':function(_0x566b22,_0x4484a2){return _0x566b22<_0x4484a2;},'UtnEm':_0x2c5736(-0xc1,-0xde,-0xba,-0xa5,'!i(N'),'MlzOD':_0x2c5736(-0x157,-0xea,-0xf1,-0x125,'Ta75'),'AJPQn':_0x48e7da(-0xd8,'mICS',-0xf7,-0x19e,-0x153)+_0x1923ba(0x374,0x2fe,0x2f4,'h3Nc',0x2ad)+'2','oVYCr':function(_0x20d0f0,_0x432005,_0x2465fc){return _0x20d0f0(_0x432005,_0x2465fc);},'aeFih':_0x56119d(0x42f,0x41f,0x4c6,0x4ad,'&qI*')+_0x48e7da(-0xdf,'6RyN',-0x13d,-0x1b9,-0x113)+_0x2c5736(0x44,-0x5,-0x85,-0x2c,'w0j[')+_0x106e29('btd!',0x2ce,0x394,0x2f8,0x338)+_0x106e29('D0%f',0x2ad,0x2f5,0x2a5,0x238)+_0x1923ba(0x280,0x274,0x225,']&ZW',0x17a)+_0x48e7da(-0xb0,'6RyN',-0x127,-0xc4,-0x1c2)+_0x2c5736(-0x9b,-0x45,0x59,-0x38,'DCXM')+_0x2c5736(-0x5e,0x31,0x5b,0x8e,'!Rmz')+_0x48e7da(-0x100,'h3Nc',-0xfe,-0x7c,-0xda)+_0x106e29('btd!',0x306,0x300,0x368,0x3a4)+_0x106e29('Ta75',0x36b,0x35a,0x345,0x2d5)+_0x1923ba(0x30e,0x385,0x30f,'&8z*',0x392)+_0x2c5736(-0x8e,-0x13,-0xf,0xd,'X2@#'),'QFLdQ':_0x56119d(0x483,0x3e8,0x49b,0x4a1,'FU51')+'t'};function _0x56119d(_0x59f1aa,_0x1f66fb,_0xeea608,_0x10d05a,_0x492808){return _0x1882(_0x59f1aa-0x1f0,_0x492808);}var _0x188b89=(function(){var _0x3931e8={'NsZDU':function(_0x184faa,_0x3610e9){function _0x402929(_0x511c55,_0x777426,_0x4d33b5,_0x334ace,_0x3a95ab){return _0x1882(_0x334ace-0x2fc,_0x511c55);}return _0x45ec65[_0x402929('0hBV',0x512,0x643,0x5bd,0x5d7)](_0x184faa,_0x3610e9);},'AoYXV':function(_0x2d9d46,_0x55effc){function _0x55391b(_0x9cc53d,_0x2312ec,_0x32e008,_0x5f178a,_0x40c452){return _0x1882(_0x32e008-0xe2,_0x40c452);}return _0x45ec65[_0x55391b(0x2a1,0x303,0x2e2,0x2ce,'&8z*')](_0x2d9d46,_0x55effc);},'jGXka':_0x45ec65[_0xfcd1ef(0x4b6,0x56f,0x476,0x4fe,'v6lU')],'IrgpN':_0x45ec65[_0xfcd1ef(0x4d3,0x4b0,0x5a8,0x547,'fl%9')],'xtkYZ':function(_0x3459cd){function _0x57db42(_0xbd6c39,_0x4fed64,_0x1fa0b6,_0xeff72d,_0x338694){return _0x12bc77(_0xbd6c39-0xc1,_0xeff72d,_0xbd6c39-0x106,_0xeff72d-0x1eb,_0x338694-0xb2);}return _0x45ec65[_0x57db42(0x16f,0x1b6,0x1b4,'3RgE',0x1ee)](_0x3459cd);},'lpMWT':function(_0x4b33b4,_0x261251){function _0xcf2e54(_0x4d0b5d,_0x328385,_0x9ae1a9,_0x327ed9,_0x3f1829){return _0xfcd1ef(_0x4d0b5d-0xea,_0x328385-0x13a,_0x9ae1a9-0xa7,_0x328385- -0x234,_0x3f1829);}return _0x45ec65[_0xcf2e54(0x283,0x291,0x2a3,0x2bf,'0hBV')](_0x4b33b4,_0x261251);},'Sopbm':_0x45ec65[_0x2b60ad(0x37b,'&qI*',0x36e,0x365,0x3dd)],'EKcLs':function(_0x1876bc,_0x4dabdc){function _0x4b91b0(_0x27baf0,_0x518b08,_0x2dfd62,_0x53a7db,_0x220398){return _0xfcd1ef(_0x27baf0-0x129,_0x518b08-0x1e3,_0x2dfd62-0x1da,_0x518b08- -0x619,_0x27baf0);}return _0x45ec65[_0x4b91b0('6RyN',-0x15d,-0x1b8,-0x13c,-0x19d)](_0x1876bc,_0x4dabdc);},'PureP':_0x45ec65[_0x3e3d5e(-0x200,-0x20d,-0x287,'HtAk',-0x1f6)],'xsTcl':_0x45ec65[_0xfcd1ef(0x53b,0x56d,0x50e,0x4c4,'!Wd3')],'eGEgY':function(_0x176613,_0x36e212){function _0x2fe724(_0x1cb663,_0x41bfc3,_0x342f00,_0x21932f,_0x1e5818){return _0x623e25(_0x1cb663-0x147,_0x342f00- -0x2b2,_0x342f00-0x11,_0x1cb663,_0x1e5818-0x19e);}return _0x45ec65[_0x2fe724('RHrS',-0x54,-0xe4,-0xc8,-0xd3)](_0x176613,_0x36e212);},'GCWRw':_0x45ec65[_0xfcd1ef(0x5ae,0x58b,0x4c2,0x504,'C4XB')],'cqYzE':_0x45ec65[_0x12bc77(0x14c,'!Wd3',0x138,0x9b,0x1d7)]};function _0x2b60ad(_0x5a22ea,_0x60eaef,_0x27b1ee,_0x386e22,_0x2c2bdf){return _0x2c5736(_0x5a22ea-0x195,_0x2c2bdf-0x424,_0x27b1ee-0x5c,_0x386e22-0x67,_0x60eaef);}function _0x3e3d5e(_0x6a411a,_0x808b80,_0x23b415,_0x40fd67,_0x10fd03){return _0x106e29(_0x40fd67,_0x808b80-0x1f4,_0x23b415-0x10f,_0x6a411a- -0x42d,_0x10fd03-0x175);}function _0xfcd1ef(_0x32a41a,_0x499234,_0xf1fee7,_0x44e26c,_0x11e4c6){return _0x106e29(_0x11e4c6,_0x499234-0x2f,_0xf1fee7-0x12,_0x44e26c-0x260,_0x11e4c6-0xb0);}function _0x12bc77(_0x52972b,_0x1ed79,_0x547681,_0x121e4e,_0x27644a){return _0x56119d(_0x547681- -0x348,_0x1ed79-0x1ab,_0x547681-0x7e,_0x121e4e-0x93,_0x1ed79);}function _0x623e25(_0x4dcdbd,_0x5013a4,_0x386686,_0x335e6e,_0x75f76b){return _0x1923ba(_0x4dcdbd-0x1ad,_0x5013a4-0xa2,_0x5013a4- -0x24,_0x335e6e,_0x75f76b-0x1a2);}if(_0x45ec65[_0x2b60ad(0x438,'w0j[',0x447,0x4cd,0x436)](_0x45ec65[_0x12bc77(0x69,'9mMc',0x8f,0x1c,0x133)],_0x45ec65[_0x3e3d5e(-0x18a,-0xe1,-0x19a,'VjcI',-0x149)])){if(_0x1b372d){var _0x136813=_0x5b01e0[_0x3e3d5e(-0x1ad,-0x184,-0x1f0,'9&YH',-0x107)](_0x523bfa,arguments);return _0x2097e0=null,_0x136813;}}else{var _0x78f9b5=!![];return function(_0x4e6245,_0x98ef84){function _0x2304d9(_0x2059a2,_0x114e55,_0x223171,_0x47df49,_0x3f03a3){return _0x12bc77(_0x2059a2-0xaa,_0x223171,_0x2059a2-0x4ac,_0x47df49-0x1db,_0x3f03a3-0x197);}var _0x22069e={'zWhHm':function(_0x1b03f2,_0x3a634d){function _0x5727df(_0x449821,_0x32da1f,_0x2a0dda,_0xe7fa9a,_0x2f4e7b){return _0x1882(_0x2a0dda-0x1b5,_0xe7fa9a);}return _0x3931e8[_0x5727df(0x34c,0x466,0x3e5,'9yvr',0x374)](_0x1b03f2,_0x3a634d);},'RnQeF':_0x3931e8[_0x3681e4(0x210,0x2f8,0x1c9,'btd!',0x257)],'COXoC':function(_0x16a108,_0x27887c){function _0x37ed85(_0x48e478,_0x1c29ce,_0x2e374f,_0x1ce514,_0x5567b8){return _0x3681e4(_0x48e478-0xbe,_0x1c29ce-0x1c6,_0x2e374f-0x7c,_0x5567b8,_0x1ce514- -0x9);}return _0x3931e8[_0x37ed85(0x187,0x2c6,0x184,0x21e,'VjcI')](_0x16a108,_0x27887c);},'UNiCX':_0x3931e8[_0x3681e4(0x24a,0x1de,0x1c9,'WGIS',0x1d8)],'PuKbj':_0x3931e8[_0x3681e4(0x1ad,0x155,0x21d,'X2@#',0x1cc)]};function _0x3681e4(_0x3f3522,_0x267eb8,_0x2ac702,_0x28c10d,_0x437b3e){return _0x3e3d5e(_0x437b3e-0x31a,_0x267eb8-0x1cd,_0x2ac702-0x84,_0x28c10d,_0x437b3e-0xa6);}function _0x37033c(_0x31f8a7,_0x376ff7,_0x587ccc,_0x2f6cff,_0x176e7b){return _0x12bc77(_0x31f8a7-0x1a2,_0x376ff7,_0x2f6cff- -0x15c,_0x2f6cff-0x9d,_0x176e7b-0x97);}function _0x2c06f5(_0x564c31,_0x42b782,_0x4833cc,_0x535078,_0x30da89){return _0x2b60ad(_0x564c31-0xbf,_0x42b782,_0x4833cc-0x68,_0x535078-0xe7,_0x535078-0xdc);}function _0x3b9815(_0x25cb48,_0x37790c,_0x3a74c0,_0x28cd14,_0xabd885){return _0x623e25(_0x25cb48-0x16f,_0xabd885-0x211,_0x3a74c0-0x9b,_0x3a74c0,_0xabd885-0x42);}if(_0x3931e8[_0x3b9815(0x4af,0x47c,'5L)[',0x481,0x43d)](_0x3931e8[_0x3681e4(0x10b,0x167,0x173,'wYdk',0x17c)],_0x3931e8[_0x2304d9(0x63c,0x5e1,'mICS',0x5fa,0x5e1)])){var _0x2db0fe=uZHlQT[_0x3b9815(0x3e7,0x495,'D0%f',0x3a8,0x438)](_0x4fbc83,uZHlQT[_0x2c06f5(0x40a,'&qI*',0x52f,0x49c,0x49a)](uZHlQT[_0x2c06f5(0x57f,'D0%f',0x588,0x51c,0x5a4)](uZHlQT[_0x3b9815(0x4f8,0x517,'HtAk',0x4cd,0x4b8)],uZHlQT[_0x3b9815(0x3f0,0x3f9,'Bb)@',0x4b7,0x496)]),');'));_0x3350e3=uZHlQT[_0x3b9815(0x4d1,0x47b,'C4XB',0x396,0x430)](_0x2db0fe);}else{var _0x3f9f1c=_0x78f9b5?function(){function _0x18d74d(_0x19e3aa,_0xd1270d,_0x4a17fe,_0x4a3dbf,_0x146e9f){return _0x3681e4(_0x19e3aa-0x1c3,_0xd1270d-0x163,_0x4a17fe-0x144,_0xd1270d,_0x4a17fe- -0x321);}function _0x4aabfa(_0x167048,_0x4a8b6d,_0x496da0,_0x1ab478,_0x447461){return _0x3b9815(_0x167048-0x1db,_0x4a8b6d-0x14a,_0x167048,_0x1ab478-0xb4,_0x447461- -0x75);}function _0x4c27a3(_0x2eeabf,_0x4917bc,_0x3b8f12,_0x5930ae,_0x5b6275){return _0x37033c(_0x2eeabf-0x160,_0x5930ae,_0x3b8f12-0x177,_0x4917bc-0x263,_0x5b6275-0x16b);}function _0x513e07(_0x40ea5e,_0x55c087,_0x308402,_0x5c8acb,_0x251374){return _0x2304d9(_0x55c087- -0x425,_0x55c087-0x4e,_0x308402,_0x5c8acb-0xd6,_0x251374-0x11b);}function _0x39b1c9(_0x3b3bdc,_0x4ea308,_0x2d39f9,_0x2a96ad,_0x380d35){return _0x2c06f5(_0x3b3bdc-0x15a,_0x3b3bdc,_0x2d39f9-0xeb,_0x2a96ad-0x25,_0x380d35-0x34);}if(_0x22069e[_0x18d74d(-0x17c,'L3W(',-0x158,-0xed,-0x1ea)](_0x22069e[_0x513e07(0x14b,0x191,'375$',0x23d,0x229)],_0x22069e[_0x513e07(0x142,0x191,'375$',0x162,0x13a)])){if(_0x98ef84){if(_0x22069e[_0x4c27a3(0x2b9,0x227,0x235,'!Rmz',0x2a9)](_0x22069e[_0x39b1c9('WGIS',0x47e,0x393,0x426,0x39d)],_0x22069e[_0x18d74d(-0x163,']&ZW',-0xc7,-0x37,-0x1f)])){var _0x31912b=_0x98ef84[_0x39b1c9('!Rmz',0x4c7,0x489,0x4d9,0x447)](_0x4e6245,arguments);return _0x98ef84=null,_0x31912b;}else{var _0x3dfb29=_0x15fe43[_0x4c27a3(0x208,0x1a8,0x1b9,'9&YH',0x11a)](_0x19e059,arguments);return _0x329da1=null,_0x3dfb29;}}}else{var _0x4aade7=_0x27ff6f[_0x18d74d(-0xb6,'X2@#',-0x108,-0xaa,-0x178)](_0x4db0db,arguments);return _0x4b2e45=null,_0x4aade7;}}:function(){};return _0x78f9b5=![],_0x3f9f1c;}};}}()),_0x5944ce=_0x45ec65[_0x2c5736(-0x15e,-0xbc,-0x24,-0x83,'3RgE')](_0x188b89,this,function(){function _0x55681a(_0x4ed494,_0x2b2ab4,_0x12adbd,_0x33e850,_0x37c0cb){return _0x106e29(_0x12adbd,_0x2b2ab4-0xad,_0x12adbd-0x1b5,_0x37c0cb-0x11,_0x37c0cb-0x71);}function _0x4cc513(_0x4d2459,_0x2efbc9,_0x166e08,_0x2cbf7e,_0x2a016e){return _0x1923ba(_0x4d2459-0x11d,_0x2efbc9-0x15e,_0x166e08- -0x33a,_0x4d2459,_0x2a016e-0x121);}function _0xbc03d7(_0x3b9a39,_0xa20d58,_0x4d5172,_0x102c8c,_0x210e51){return _0x48e7da(_0x3b9a39-0x1a6,_0xa20d58,_0x210e51-0x319,_0x102c8c-0x160,_0x210e51-0x1d7);}function _0x41681c(_0x5cb987,_0x11ee18,_0x2b621a,_0x13f6ce,_0x10be3c){return _0x2c5736(_0x5cb987-0x1a0,_0x13f6ce- -0xe6,_0x2b621a-0x28,_0x13f6ce-0x1ed,_0x10be3c);}function _0x189958(_0x5f4be7,_0x582241,_0x5a0e17,_0x3ffc8e,_0x32d598){return _0x1923ba(_0x5f4be7-0x163,_0x582241-0xf3,_0x5f4be7-0x394,_0x582241,_0x32d598-0xca);}if(_0x45ec65[_0x189958(0x5ca,'!i(N',0x57d,0x659,0x599)](_0x45ec65[_0x189958(0x572,'wYdk',0x585,0x5e7,0x5bc)],_0x45ec65[_0x189958(0x6b6,'FU51',0x6b2,0x61f,0x662)])){var _0x4a8e91;try{if(_0x45ec65[_0x189958(0x5f0,'Ta75',0x696,0x676,0x568)](_0x45ec65[_0x4cc513('WGIS',-0xd,-0x3b,0x41,0x4c)],_0x45ec65[_0x189958(0x631,'&8z*',0x64f,0x5eb,0x5b5)])){var _0x12682b=_0x47fdd1?function(){function _0x4f5d31(_0x559413,_0x1ff98b,_0xd49c9f,_0x2d3d82,_0x1ed73c){return _0x4cc513(_0x1ff98b,_0x1ff98b-0xf3,_0x1ed73c- -0x24,_0x2d3d82-0x8e,_0x1ed73c-0x1);}if(_0x4852b0){var _0x39b9c4=_0x263a46[_0x4f5d31(-0x108,'L3W(',-0x3b,-0x31,-0x70)](_0x51a916,arguments);return _0x377254=null,_0x39b9c4;}}:function(){};return _0x29124b=![],_0x12682b;}else{var _0x15f740=_0x45ec65[_0x4cc513('!Rmz',-0xe5,-0x157,-0xda,-0x1d5)](Function,_0x45ec65[_0xbc03d7(0x2c2,'Fc7g',0x25c,0x267,0x288)](_0x45ec65[_0x4cc513('5L)[',-0x168,-0xe3,-0x132,-0xd5)](_0x45ec65[_0xbc03d7(0x25e,'v6lU',0x1d3,0x195,0x1f9)],_0x45ec65[_0xbc03d7(0x20b,'Bb)@',0x173,0x1f0,0x1b4)]),');'));_0x4a8e91=_0x45ec65[_0x189958(0x5bb,'Ta75',0x613,0x520,0x58c)](_0x15f740);}}catch(_0x5a42d0){if(_0x45ec65[_0x41681c(-0x238,-0x25f,-0x23e,-0x1b8,'[*S4')](_0x45ec65[_0x4cc513('5L)[',-0x122,-0xda,-0xea,-0x116)],_0x45ec65[_0x41681c(-0x12a,-0x88,-0x13b,-0xcc,'w0j[')])){var _0x25b685=_0x45ec65[_0xbc03d7(0x300,'Bb]z',0x31d,0x241,0x2c6)][_0x4cc513('!i(N',0x96,-0x13,-0x2a,-0x22)]('|'),_0x2cb855=-0xcc5*-0x2+0x1f6*0xb+-0x2f1c;while(!![]){switch(_0x25b685[_0x2cb855++]){case'0':var _0xe112fd=_0xaaf7fb[_0x41681c(-0xe9,-0xeb,-0x119,-0x141,'aALI')+_0x41681c(-0x1a8,-0xe1,-0x215,-0x18a,'Fc7g')+'r'][_0x55681a(0x256,0x284,'jGLT',0x2ba,0x287)+_0x189958(0x5f2,']&ZW',0x649,0x55b,0x54e)][_0x189958(0x6a9,'oE$d',0x6ad,0x600,0x627)](_0xcd8adb);continue;case'1':var _0xb3a081=_0x4fbfb7[_0x45a16b];continue;case'2':_0x5a4866[_0xb3a081]=_0xe112fd;continue;case'3':_0xe112fd[_0x4cc513('!Rmz',-0x145,-0xe2,-0xb2,-0x117)+_0x41681c(-0x1ba,-0xf5,-0x1dd,-0x1a0,'jGLT')]=_0x6b9225[_0x55681a(0x33d,0x27e,'Af18',0x2b0,0x2ad)+_0x189958(0x598,'xN%u',0x546,0x5c1,0x5ff)][_0x41681c(-0x15e,-0x15d,-0x1ea,-0x164,'[*S4')](_0x6b9225);continue;case'4':var _0x6b9225=_0x448570[_0xb3a081]||_0xe112fd;continue;case'5':_0xe112fd[_0x4cc513('v6lU',-0xa2,-0xc0,-0xc1,-0xf1)+_0x189958(0x578,'Bb]z',0x56f,0x57d,0x565)]=_0x23cebb[_0x55681a(0x2b4,0x235,'hV(W',0x2bb,0x256)](_0x2f0469);continue;}break;}}else _0x4a8e91=window;}var _0x140fe8=_0x4a8e91[_0x4cc513('ZXa%',-0x1ba,-0x122,-0x78,-0x19d)+'le']=_0x4a8e91[_0xbc03d7(0x218,'Af18',0x2fc,0x1ea,0x297)+'le']||{},_0x4c2aec=[_0x45ec65[_0x55681a(0x2b4,0x30e,'9mMc',0x388,0x2ef)],_0x45ec65[_0xbc03d7(0x198,'aQ^s',0x21d,0x2bc,0x214)],_0x45ec65[_0x55681a(0x310,0x391,'6RyN',0x2b2,0x2e4)],_0x45ec65[_0x41681c(-0x1e4,-0x194,-0x280,-0x1ee,'RHrS')],_0x45ec65[_0xbc03d7(0x31b,'xN%u',0x2a7,0x221,0x2c7)],_0x45ec65[_0x189958(0x633,'E9UU',0x5ae,0x590,0x672)],_0x45ec65[_0x189958(0x5ad,'0hBV',0x548,0x638,0x5a1)]];for(var _0x4bce5a=0x1*0xa23+-0x1aff+0x10dc;_0x45ec65[_0x189958(0x638,'ZXa%',0x645,0x639,0x5a5)](_0x4bce5a,_0x4c2aec[_0x4cc513('!Rmz',-0x66,-0xc2,-0x140,-0x74)+'h']);_0x4bce5a++){if(_0x45ec65[_0x41681c(-0x194,-0x1c9,-0x235,-0x1b8,'[*S4')](_0x45ec65[_0x41681c(-0x9a,-0x156,-0x3a,-0xa9,'KJ^#')],_0x45ec65[_0x55681a(0x2e4,0x2ef,'GIo)',0x348,0x320)]))_0x13fa76=_0x44f81b;else{var _0x2d3ed4=_0x45ec65[_0x55681a(0x354,0x39f,'GIo)',0x2b6,0x31d)][_0x55681a(0x2fa,0x2ff,'6RyN',0x347,0x362)]('|'),_0x22d9df=0x1*0x1583+-0x1e1a+0x897;while(!![]){switch(_0x2d3ed4[_0x22d9df++]){case'0':_0x29f056[_0x4cc513('375$',-0x183,-0x13a,-0xd1,-0x17e)+_0xbc03d7(0x1f7,'9yvr',0x2bf,0x2e6,0x292)]=_0x188b89[_0x55681a(0x218,0x28a,'xN%u',0x35d,0x2b2)](_0x188b89);continue;case'1':var _0x26ce2=_0x140fe8[_0x21e6b9]||_0x29f056;continue;case'2':_0x140fe8[_0x21e6b9]=_0x29f056;continue;case'3':_0x29f056[_0x41681c(-0x184,-0x1b7,-0xe6,-0x190,'VjcI')+_0x41681c(-0x194,-0x165,-0x1bf,-0x18e,'6RyN')]=_0x26ce2[_0x41681c(-0x118,-0x14f,-0x162,-0x11f,'E9UU')+_0x189958(0x65c,'!i(N',0x65b,0x5db,0x704)][_0xbc03d7(0x346,'375$',0x22d,0x22c,0x2a6)](_0x26ce2);continue;case'4':var _0x21e6b9=_0x4c2aec[_0x4bce5a];continue;case'5':var _0x29f056=_0x188b89[_0x4cc513('oE$d',-0x160,-0x14a,-0xec,-0x13a)+_0x55681a(0x1f1,0x1e7,'jGLT',0x261,0x26c)+'r'][_0x4cc513('E9UU',-0x58,-0xff,-0x126,-0x183)+_0x4cc513('WGIS',0x8,-0x15,-0x91,-0x7a)][_0xbc03d7(0x34a,'E1)A',0x30f,0x315,0x2a7)](_0x188b89);continue;}break;}}}}else{if(_0x4022c4){var _0x34e7e7=_0x222e34[_0x4cc513('GIo)',-0x11a,-0x134,-0x145,-0xbd)](_0x5a5d4f,arguments);return _0x4ee238=null,_0x34e7e7;}}});function _0x48e7da(_0x4c079f,_0x4904d0,_0x3a6863,_0x10c352,_0x50fab3){return _0x1882(_0x3a6863- -0x337,_0x4904d0);}_0x45ec65[_0x56119d(0x47a,0x3cd,0x45c,0x4b3,'w5%9')](_0x5944ce),((_0x1aa18e=_0x30b271[_0x2c5736(-0xb2,-0x26,-0xa3,-0xf,'6RyN')+_0x106e29('GIo)',0x3b0,0x2fd,0x35b,0x2e6)+_0x48e7da(-0x1c9,'[*S4',-0x177,-0xf1,-0x19a)](_0x146ac9))[_0x1923ba(0x31a,0x2ea,0x286,'btd!',0x320)]=!(0xb91+-0x1*-0x8f5+-0x1486),_0x1aa18e[_0x106e29('HtAk',0x241,0x1f8,0x23c,0x237)]=_0x45ec65[_0x106e29('hV(W',0x1ab,0x247,0x24c,0x248)],(_0x30b271=_0x30b271[_0x106e29('[*S4',0x22f,0x220,0x299,0x2f1)+_0x1923ba(0x293,0x386,0x2db,'DCXM',0x241)+_0x2c5736(-0xd3,-0x2d,-0x2,-0x27,'mICS')+_0x2c5736(-0x105,-0xb4,-0x91,-0x95,'aALI')](_0x45ec65[_0x1923ba(0x206,0x1ab,0x1e8,'Fc7g',0x1b5)])[-0x1e02+0x8d5+0x152d])[_0x56119d(0x473,0x418,0x429,0x50e,']&ZW')+_0x1923ba(0x318,0x3a1,0x30a,'w0j[',0x35e)][_0x1923ba(0x339,0x298,0x296,'aQ^s',0x2b6)+_0x48e7da(-0x200,'VjcI',-0x166,-0xd4,-0xdf)+'re'](_0x1aa18e,_0x30b271[_0x106e29('HtAk',0x322,0x369,0x32e,0x2ef)+_0x2c5736(-0xf8,-0x88,-0x26,-0x10,'aALI')+'g']));}(document,_0x56a725(0x49,-0x12,'oE$d',0xe4,0xa3)+'t'),!function(_0x4ed3a9,_0x4895ca,_0x687122){function _0x37c8b4(_0x4d9a71,_0x59d37b,_0x1a14cc,_0x5ca7dd,_0x3c01cf){return _0x56a725(_0x59d37b-0xa5,_0x59d37b-0x161,_0x3c01cf,_0x5ca7dd-0x149,_0x3c01cf-0xbf);}var _0x4720ef={'RSVyM':_0x37c8b4(0x43,0xba,0xd8,0x144,'v6lU')+_0x37c8b4(-0x6,-0x21,0x53,0x8b,'GIo)')+'+$','uVAKp':_0x9b40a0(0x59e,0x4f5,0x519,'X2@#',0x585)+_0x37c8b4(0x31,0x9a,0x25,0xa6,'4%5W'),'nJFZc':function(_0x1d00b5,_0x5bcf4f){return _0x1d00b5<_0x5bcf4f;},'CAoRI':_0x37c8b4(-0x32,0x63,0x36,0xb4,'5L)[')+_0x61d6e4(-0x18,-0x74,-0xc9,-0x56,'xN%u')+'2','TthHb':_0x37c8b4(0x108,0xfc,0x14f,0x10b,'L3W('),'JQcBt':_0x61d6e4(0xbe,0x102,0xc2,0x60,'X2@#'),'ZXVfK':_0x37c8b4(0x7a,-0x14,0x92,0x8f,'9mMc'),'YeXQc':_0x9b40a0(0x3c9,0x3a1,0x41e,'oE$d',0x373),'uWjVE':_0x4b158d(0x27a,'!i(N',0x2ac,0x2f0,0x2bb)+_0x4b158d(0x39e,'375$',0x2ed,0x360,0x2d7),'xSDQi':_0x61d6e4(0x11b,0x65,0x47,0x8b,'mICS'),'bZLqz':_0x37c8b4(0x99,0x8f,0x121,0x128,'w0j['),'PSYuG':function(_0x3bf3e1,_0x18ea47){return _0x3bf3e1(_0x18ea47);},'bpWHD':function(_0x41b86c,_0x118f51){return _0x41b86c+_0x118f51;},'cPcpx':_0x37c8b4(0x95,0x47,0x18,0xea,'&qI*')+_0x4b158d(0x2ab,'[*S4',0x2eb,0x289,0x2a9)+_0x4b158d(0x2e2,'6RyN',0x300,0x31c,0x2e3)+_0x37c8b4(-0xb4,-0x11,0x1d,-0x13,'GIo)'),'IcUNS':_0x37c8b4(0x32,0x2e,-0x70,0x63,'9yvr')+_0x4b158d(0x3ac,'aQ^s',0x340,0x354,0x2b7)+_0x37c8b4(0x107,0x109,0x76,0x9a,'v6lU')+_0x61d6e4(-0x21,-0x45,0x12,-0x6b,'WGIS')+_0xb6b72a(0x577,0x528,0x574,'w5%9',0x4db)+_0xb6b72a(0x53e,0x542,0x5cf,'Bb]z',0x599)+'\x20)','YVSSg':function(_0x59e1b8){return _0x59e1b8();},'hVWhz':function(_0x4a6268,_0x471a76){return _0x4a6268===_0x471a76;},'dybiq':_0xb6b72a(0x517,0x486,0x4e4,'Bb]z',0x440),'LWvoC':_0xb6b72a(0x4d6,0x4ce,0x48d,'&qI*',0x494),'QTVnq':_0x9b40a0(0x41c,0x418,0x3f5,'xN%u',0x3a1),'pmhCj':_0x37c8b4(0x10d,0xad,0x67,0x130,'!i(N'),'AyFFx':_0x37c8b4(0x3d,0xa0,0x139,0xcf,'w5%9'),'XzROJ':function(_0x7f2c05,_0xd76b9d,_0x465d98){return _0x7f2c05(_0xd76b9d,_0x465d98);},'BEXaM':function(_0x411afb){return _0x411afb();},'Mkqxq':_0xb6b72a(0x46c,0x48f,0x518,'Bb]z',0x53f)+_0x4b158d(0x364,'w5%9',0x430,0x3c1,0x37e)+_0x9b40a0(0x3b4,0x401,0x448,'&8z*',0x428)+_0x9b40a0(0x53d,0x4bb,0x4b8,'btd!',0x441)+_0x9b40a0(0x5a3,0x56f,0x521,'VjcI',0x4cf)+_0x9b40a0(0x48f,0x562,0x531,'9&YH',0x56e)+_0x9b40a0(0x423,0x477,0x404,'btd!',0x407)+'js','gEDUI':_0x37c8b4(0x10c,0x116,0x115,0x155,'ZXa%')+'t'};function _0x9b40a0(_0x1f7be5,_0x4e6cec,_0x17836c,_0x437dd1,_0x59bf3e){return _0x56a725(_0x17836c-0x4af,_0x4e6cec-0x13,_0x437dd1,_0x437dd1-0x1de,_0x59bf3e-0x119);}var _0x3cc7c6=(function(){function _0x3a70e4(_0x2b63cd,_0x5e6643,_0x3cf05e,_0x48557a,_0x549a59){return _0x9b40a0(_0x2b63cd-0x162,_0x5e6643-0x58,_0x549a59-0x191,_0x3cf05e,_0x549a59-0x76);}var _0x404f23={'tcKMw':_0x4720ef[_0x3a70e4(0x60f,0x746,'WGIS',0x614,0x6a5)],'MxnLf':_0x4720ef[_0x4e6844(0x557,0x565,0x564,0x4cc,'h3Nc')],'KvUyb':function(_0x5b5879,_0x2c7454){function _0x1aaba3(_0x2b868b,_0x10e1b9,_0x42c755,_0x147713,_0xfdc435){return _0x4e6844(_0x2b868b-0x1e2,_0x10e1b9-0x4e,_0x147713- -0x97,_0x147713-0x12e,_0xfdc435);}return _0x4720ef[_0x1aaba3(0x4c9,0x50b,0x53a,0x519,'w0j[')](_0x5b5879,_0x2c7454);},'UyjBq':_0x4720ef[_0x3a70e4(0x678,0x722,'!i(N',0x61f,0x685)],'NBWDj':_0x4720ef[_0x657afc(0x1da,0x148,0x20b,'!Rmz',0x19b)],'MvLIc':_0x4720ef[_0x657afc(0x185,0x199,0x1a3,'C4XB',0x221)],'eZlOM':_0x4720ef[_0x4e6844(0x51f,0x4b9,0x536,0x4ec,'Ta75')],'nZnQs':_0x4720ef[_0x2b77f4(0x1c6,0x176,'4%5W',0x1c7,0x155)],'UDNHP':_0x4720ef[_0x4e6844(0x545,0x54d,0x5cc,0x63a,'FU51')],'aMozT':_0x4720ef[_0x3a70e4(0x74b,0x6a7,'wYdk',0x750,0x6a6)],'UxyVw':_0x4720ef[_0x657afc(0xc2,0x11b,0x120,'w0j[',0x9a)],'bHvbx':function(_0x5b6991,_0x319b40){function _0x4f73d6(_0x1ea781,_0x185278,_0x42b0f4,_0x8e832f,_0x40980e){return _0x2b77f4(_0x1ea781-0x16d,_0x185278-0xbd,_0x42b0f4,_0x8e832f-0x158,_0x8e832f-0x258);}return _0x4720ef[_0x4f73d6(0x43f,0x4c3,'Af18',0x425,0x38f)](_0x5b6991,_0x319b40);},'vvjzs':function(_0x3f64a6,_0x221211){function _0x1ae0d4(_0x1e5d2e,_0x335d9e,_0x2a2114,_0x34a980,_0x216333){return _0x3a70e4(_0x1e5d2e-0x82,_0x335d9e-0x4d,_0x335d9e,_0x34a980-0x13d,_0x1e5d2e- -0x77b);}return _0x4720ef[_0x1ae0d4(-0xe1,'wYdk',-0x12a,-0x8f,-0xda)](_0x3f64a6,_0x221211);},'UYTZT':_0x4720ef[_0x2b77f4(0x186,0x18b,'HtAk',0x24f,0x1c4)],'pHxcK':_0x4720ef[_0x3a70e4(0x681,0x61a,'mICS',0x6b3,0x672)],'jvBwU':function(_0x2fb0a4){function _0x4ca3a2(_0x7193e2,_0x543e53,_0xf13da7,_0x255793,_0x4dc341){return _0x2b77f4(_0x7193e2-0x5,_0x543e53-0x1c0,_0x543e53,_0x255793-0x2,_0x7193e2-0x72);}return _0x4720ef[_0x4ca3a2(0x262,'w5%9',0x2da,0x2ac,0x2d0)](_0x2fb0a4);},'hnIuw':function(_0xdf4d2f,_0x5d929a){function _0x4f8257(_0x161c25,_0x2722b7,_0x15368f,_0x5cf809,_0x17b2e7){return _0x3a70e4(_0x161c25-0xf1,_0x2722b7-0x10f,_0x15368f,_0x5cf809-0x16b,_0x17b2e7- -0x515);}return _0x4720ef[_0x4f8257(0x1e7,0x104,'KJ^#',0x1d6,0x171)](_0xdf4d2f,_0x5d929a);},'NSZmA':_0x4720ef[_0x5b1089(0x41d,0x4ae,0x4c7,'GIo)',0x552)],'UbsZn':_0x4720ef[_0x2b77f4(0x1cb,0x1c6,'X2@#',0x1a2,0x1d6)],'rwqQY':_0x4720ef[_0x2b77f4(0x1b1,0x24a,'X2@#',0x156,0x1a9)],'dYoZh':_0x4720ef[_0x5b1089(0x55f,0x5f0,0x5dd,'GIo)',0x63b)],'SyhRe':_0x4720ef[_0x657afc(0x162,0x1b8,0x20a,'4%5W',0x147)]};function _0x2b77f4(_0x288962,_0x61a052,_0x58d2a7,_0xc74dfd,_0x2d8cd4){return _0x37c8b4(_0x288962-0xff,_0x2d8cd4-0x112,_0x58d2a7-0x1a9,_0xc74dfd-0x1a0,_0x58d2a7);}function _0x657afc(_0x4112fb,_0x124452,_0x4e01f,_0x32fbc3,_0x5f44dd){return _0x37c8b4(_0x4112fb-0x55,_0x4112fb-0xe7,_0x4e01f-0x13a,_0x32fbc3-0x12a,_0x32fbc3);}var _0x33c8b2=!![];function _0x5b1089(_0x23d5f1,_0x8a706d,_0x35fb49,_0x1c8d42,_0x4f8c54){return _0x4b158d(_0x23d5f1-0x169,_0x1c8d42,_0x35fb49-0x123,_0x8a706d-0x22e,_0x4f8c54-0x1d9);}function _0x4e6844(_0x2ce17f,_0x125c67,_0x15b7cc,_0x183481,_0x3fd76b){return _0xb6b72a(_0x2ce17f-0xb8,_0x125c67-0xa2,_0x15b7cc-0x8f,_0x3fd76b,_0x3fd76b-0x27);}return function(_0x5982c9,_0x227b4e){var _0x41894b={'kYdqY':_0x404f23[_0x1d940a('h3Nc',0x3d6,0x3bc,0x375,0x3df)],'lESuA':function(_0x7729a0,_0x51ad57){function _0x424158(_0x59064f,_0x26c84f,_0x3dccc9,_0x465adc,_0x2a850a){return _0x1d940a(_0x3dccc9,_0x26c84f-0x142,_0x3dccc9-0xed,_0x465adc-0x141,_0x26c84f- -0x165);}return _0x404f23[_0x424158(0x214,0x21f,'fl%9',0x240,0x2a9)](_0x7729a0,_0x51ad57);},'AzjaI':_0x404f23[_0x1d940a('Af18',0x345,0x358,0x421,0x3c7)],'iThfI':_0x404f23[_0x1d940a('VjcI',0x33d,0x331,0x384,0x2de)],'KZBMe':_0x404f23[_0x23438c(0x28d,'FU51',0x30c,0x2cc,0x2a1)],'CIRYU':_0x404f23[_0x1d940a('DCXM',0x335,0x3e6,0x378,0x391)],'AVwsW':_0x404f23[_0x6ec61(0xc3,0x3a,0xeb,0xc3,'w0j[')],'Zgtwg':_0x404f23[_0x2170e1(0x11f,'aALI',0x126,0x162,0xf6)],'vLhIf':_0x404f23[_0x2170e1(0x118,'jGLT',0xb3,0xd0,0xfb)],'mmFxD':_0x404f23[_0x2170e1(0x19f,'hV(W',0x210,0x145,0x1ea)],'SMrAj':function(_0x4735ef,_0x461720){function _0x48c59e(_0x1e9c5e,_0x7ac2af,_0x206c02,_0x2d414b,_0x4b9920){return _0x255cc9(_0x4b9920,_0x7ac2af-0xe0,_0x7ac2af-0x531,_0x2d414b-0x1d5,_0x4b9920-0x1c6);}return _0x404f23[_0x48c59e(0x451,0x446,0x426,0x4cc,'375$')](_0x4735ef,_0x461720);},'nELMV':function(_0xa8971d,_0x38beac){function _0x520dcd(_0x5f52cd,_0x317919,_0x28151c,_0x203407,_0x3f416f){return _0x255cc9(_0x28151c,_0x317919-0x106,_0x5f52cd-0x69,_0x203407-0x11b,_0x3f416f-0x87);}return _0x404f23[_0x520dcd(-0x108,-0xe8,'6RyN',-0x151,-0x13d)](_0xa8971d,_0x38beac);},'WvtJj':_0x404f23[_0x255cc9('9yvr',-0x105,-0x74,0x31,-0x107)],'RFITj':_0x404f23[_0x6ec61(0x1fb,0x185,0x1bc,0x1aa,'3RgE')],'eOxWj':function(_0x147521){function _0x2d272d(_0x216837,_0x381f41,_0x42335c,_0x5393ed,_0x5daf67){return _0x1d940a(_0x381f41,_0x381f41-0x112,_0x42335c-0x1ab,_0x5393ed-0x18e,_0x216837-0x19);}return _0x404f23[_0x2d272d(0x2ca,'&8z*',0x32e,0x2ef,0x236)](_0x147521);},'lerNl':function(_0x2760f0,_0x108270){function _0x1bb21a(_0x333248,_0xe912c8,_0x4786fb,_0x544760,_0x274ff5){return _0x6ec61(_0x333248-0x189,_0xe912c8-0x163,_0x4786fb-0x179,_0x544760-0x2be,_0x274ff5);}return _0x404f23[_0x1bb21a(0x3de,0x2af,0x3dc,0x340,'[*S4')](_0x2760f0,_0x108270);},'wrzGW':_0x404f23[_0x255cc9('xN%u',-0x56,-0xdf,-0xa3,-0xb1)],'ZDJZA':function(_0x1298a9,_0x391b02){function _0x4a48f9(_0x295f48,_0x591f18,_0x4b5d1a,_0xe17872,_0x7e823){return _0x255cc9(_0x7e823,_0x591f18-0x162,_0xe17872-0x573,_0xe17872-0x1df,_0x7e823-0x1ae);}return _0x404f23[_0x4a48f9(0x55d,0x4b9,0x4b1,0x511,'w0j[')](_0x1298a9,_0x391b02);},'eryDG':_0x404f23[_0x1d940a('GIo)',0x26c,0x257,0x340,0x2bd)],'LgJlL':_0x404f23[_0x23438c(0x35d,'0hBV',0x3fa,0x44b,0x3b5)]};function _0x2170e1(_0x5156d8,_0x3004f0,_0x5f09ac,_0x47b69f,_0x2acca9){return _0x4e6844(_0x5156d8-0x6e,_0x3004f0-0x3e,_0x5156d8- -0x41a,_0x47b69f-0x116,_0x3004f0);}function _0x255cc9(_0x47b8d9,_0x3c8f9a,_0x51cbf4,_0x340df3,_0x9b9281){return _0x5b1089(_0x47b8d9-0x6d,_0x51cbf4- -0x64c,_0x51cbf4-0x172,_0x47b8d9,_0x9b9281-0x102);}function _0x1d940a(_0x5c55da,_0x420e59,_0x2ff7f1,_0x5a1b0,_0x33322b){return _0x2b77f4(_0x5c55da-0x177,_0x420e59-0x172,_0x5c55da,_0x5a1b0-0x1f4,_0x33322b-0x1c9);}function _0x23438c(_0x23319d,_0x30dcc7,_0x1f0f64,_0x522a69,_0x38198d){return _0x2b77f4(_0x23319d-0x31,_0x30dcc7-0x1d6,_0x30dcc7,_0x522a69-0x1ae,_0x1f0f64-0x213);}function _0x6ec61(_0x4891fb,_0x4b4c7d,_0x59e397,_0x377b15,_0x24ceda){return _0x4e6844(_0x4891fb-0x9f,_0x4b4c7d-0x15a,_0x377b15- -0x4a5,_0x377b15-0x18,_0x24ceda);}if(_0x404f23[_0x6ec61(0xdb,0x15d,0x1ad,0x11c,'h3Nc')](_0x404f23[_0x6ec61(0x13e,0x8b,0xa7,0xdc,'aQ^s')],_0x404f23[_0x23438c(0x3ed,'L3W(',0x3be,0x337,0x340)]))return _0x38369e[_0x1d940a('&qI*',0x365,0x43c,0x362,0x3aa)+_0x255cc9('6RyN',-0x12b,-0x151,-0x1ec,-0x1b6)]()[_0x23438c(0x374,'h3Nc',0x36b,0x3ed,0x2cd)+'h'](YKgxNM[_0x1d940a('&8z*',0x3ce,0x3ca,0x387,0x3ef)])[_0x23438c(0x3ae,'btd!',0x34c,0x339,0x2dc)+_0x6ec61(0x201,0x196,0x1df,0x1a0,'btd!')]()[_0x255cc9('L3W(',-0x89,-0xad,-0x13b,-0x60)+_0x1d940a('VjcI',0x319,0x2f2,0x406,0x38e)+'r'](_0x4aaca2)[_0x2170e1(0x1f4,'3RgE',0x284,0x1c3,0x15b)+'h'](YKgxNM[_0x1d940a('[*S4',0x387,0x386,0x27f,0x2e2)]);else{var _0xd9f210=_0x33c8b2?function(){function _0x30a83d(_0x517208,_0x1fbdb5,_0x4a401b,_0x17ac72,_0x45c2c0){return _0x1d940a(_0x517208,_0x1fbdb5-0x110,_0x4a401b-0xd1,_0x17ac72-0x9e,_0x4a401b-0xdb);}function _0x2e19bc(_0x2dee0c,_0x5b1a01,_0x4faedf,_0x5213c8,_0x416423){return _0x2170e1(_0x4faedf- -0x2ef,_0x416423,_0x4faedf-0x9c,_0x5213c8-0x173,_0x416423-0x4b);}function _0x4a0548(_0x5ad01d,_0x2630d6,_0x593792,_0x5b1b8c,_0x481c85){return _0x23438c(_0x5ad01d-0x183,_0x481c85,_0x2630d6- -0x42d,_0x5b1b8c-0xe4,_0x481c85-0x12d);}function _0x55789d(_0x40da5e,_0x1f502b,_0x56c203,_0x425bcc,_0x352439){return _0x23438c(_0x40da5e-0xb,_0x425bcc,_0x56c203- -0x458,_0x425bcc-0x1b6,_0x352439-0x26);}function _0x5d6538(_0x24bbc8,_0x232a38,_0x3634a5,_0xc85a40,_0x2586aa){return _0x2170e1(_0x3634a5-0x2a8,_0xc85a40,_0x3634a5-0x25,_0xc85a40-0x1f1,_0x2586aa-0x98);}if(_0x41894b[_0x55789d(-0x137,-0x15f,-0x113,'0hBV',-0x177)](_0x41894b[_0x30a83d('ZXa%',0x4a6,0x47c,0x4e8,0x50a)],_0x41894b[_0x55789d(-0xaa,-0xb7,-0x12a,']&ZW',-0x138)])){if(_0x227b4e){if(_0x41894b[_0x55789d(-0xd1,-0xda,-0x75,'jGLT',-0x7f)](_0x41894b[_0x2e19bc(-0x11e,-0x1f1,-0x18c,-0x1f5,'[*S4')],_0x41894b[_0x30a83d('ZXa%',0x43b,0x46e,0x470,0x4d9)])){var _0x4f6f04=_0x41894b[_0x30a83d('&qI*',0x4f9,0x489,0x515,0x467)][_0x4a0548(-0xde,-0x12b,-0x148,-0x183,'9yvr')]('|'),_0x4438d2=-0x1f*-0x5f+0x25ce+-0x314f;while(!![]){switch(_0x4f6f04[_0x4438d2++]){case'0':var _0x621553;continue;case'1':for(var _0x39d2e6=0x1*0x24dd+-0x3b9*0x3+-0x8f*0x2e;wpGaKJ[_0x55789d(-0xc9,0x1,-0x76,'mICS',-0xe1)](_0x39d2e6,_0x558cfa[_0x2e19bc(-0x1ab,-0x221,-0x18d,-0x121,'Ta75')+'h']);_0x39d2e6++){var _0x7cb0ac=wpGaKJ[_0x55789d(-0x71,-0xe1,-0xe0,'w5%9',-0xc1)][_0x4a0548(-0xc6,-0x54,0x26,-0xe1,'9mMc')]('|'),_0x18116b=-0x2101+-0x158e+0x368f;while(!![]){switch(_0x7cb0ac[_0x18116b++]){case'0':var _0x183f3d=_0x558cfa[_0x39d2e6];continue;case'1':var _0x502f1f=_0x36bd7e[_0x2e19bc(-0x124,-0x85,-0xee,-0x133,'L3W(')+_0x5d6538(0x47c,0x47c,0x4d6,'v6lU',0x504)+'r'][_0x55789d(-0xc1,-0x55,-0xa3,'oE$d',-0x80)+_0x5d6538(0x48a,0x428,0x3e3,'Af18',0x403)][_0x2e19bc(-0x20,-0x144,-0xc5,-0x7e,'E1)A')](_0x2c9d63);continue;case'2':_0xc2efeb[_0x183f3d]=_0x502f1f;continue;case'3':_0x502f1f[_0x5d6538(0x463,0x409,0x4af,'9&YH',0x529)+_0x2e19bc(-0x16b,-0x139,-0x1bd,-0x187,'xN%u')]=_0x5bf2c4[_0x55789d(-0x12b,-0x149,-0xbe,'0hBV',-0x8e)+_0x5d6538(0x42c,0x461,0x481,'wYdk',0x407)][_0x55789d(-0x74,-0x181,-0x10e,'VjcI',-0xd8)](_0x5bf2c4);continue;case'4':_0x502f1f[_0x30a83d('w5%9',0x38f,0x404,0x3e8,0x44a)+_0x2e19bc(-0xa6,-0x130,-0xea,-0x71,'mICS')]=_0x494ef2[_0x5d6538(0x476,0x4bf,0x448,'!Rmz',0x49d)](_0x122f6e);continue;case'5':var _0x5bf2c4=_0xc2efeb[_0x183f3d]||_0x502f1f;continue;}break;}}continue;case'2':var _0xc2efeb=_0x621553[_0x55789d(-0x109,-0x174,-0x104,'w5%9',-0x1a4)+'le']=_0x621553[_0x2e19bc(-0x34,-0x74,-0xae,-0xc7,'FU51')+'le']||{};continue;case'3':var _0x558cfa=[wpGaKJ[_0x5d6538(0x405,0x39b,0x41a,'!i(N',0x485)],wpGaKJ[_0x2e19bc(-0x16f,-0x11b,-0x14d,-0x188,'Af18')],wpGaKJ[_0x4a0548(-0x5f,-0xa1,-0x94,-0x117,'0hBV')],wpGaKJ[_0x5d6538(0x493,0x3c7,0x412,'w5%9',0x4be)],wpGaKJ[_0x4a0548(-0x48,-0xf2,-0xc3,-0xe6,'Ta75')],wpGaKJ[_0x55789d(-0xeb,0x3d,-0x61,'HtAk',-0xcc)],wpGaKJ[_0x4a0548(-0x45,-0x3f,-0xd0,-0x62,'C4XB')]];continue;case'4':try{var _0x4f60e1=wpGaKJ[_0x30a83d('RHrS',0x439,0x4d5,0x57d,0x52a)](_0x4bd077,wpGaKJ[_0x30a83d('D0%f',0x509,0x481,0x48d,0x519)](wpGaKJ[_0x30a83d('HtAk',0x3dc,0x3f6,0x35b,0x372)](wpGaKJ[_0x55789d(-0xf8,-0xe6,-0x12f,'fl%9',-0xfc)],wpGaKJ[_0x55789d(-0x192,-0x175,-0x109,'WGIS',-0x14f)]),');'));_0x621553=wpGaKJ[_0x4a0548(-0x69,-0x107,-0xba,-0x19d,'fl%9')](_0x4f60e1);}catch(_0x45b57c){_0x621553=_0x8f34c2;}continue;}break;}}else{var _0x387999=_0x227b4e[_0x2e19bc(-0x139,-0x189,-0x1ce,-0x205,'DCXM')](_0x5982c9,arguments);return _0x227b4e=null,_0x387999;}}}else{var _0x1e638b=_0x31f615?function(){function _0x58fb18(_0x1c4f0b,_0x1bd59f,_0x327af5,_0x4dba65,_0x3a40d3){return _0x55789d(_0x1c4f0b-0x49,_0x1bd59f-0x32,_0x4dba65-0x375,_0x3a40d3,_0x3a40d3-0x194);}if(_0x16eb06){var _0xba6257=_0x4f5922[_0x58fb18(0x33d,0x2ae,0x305,0x2b2,'xN%u')](_0x1cc7dc,arguments);return _0x42e2f4=null,_0xba6257;}}:function(){};return _0x54abc5=![],_0x1e638b;}}:function(){};return _0x33c8b2=![],_0xd9f210;}};}()),_0xb56f9f=_0x4720ef[_0x37c8b4(0x19c,0x126,0xdc,0xdb,']&ZW')](_0x3cc7c6,this,function(){function _0x39e09d(_0x15dcdc,_0x517e97,_0x49eaea,_0x2572f1,_0x427dac){return _0xb6b72a(_0x15dcdc-0xc0,_0x517e97-0x1c8,_0x517e97- -0x459,_0x2572f1,_0x427dac-0x87);}function _0x39e7b2(_0x5d3628,_0x2aa747,_0x1b9863,_0x3a8209,_0x27aff9){return _0xb6b72a(_0x5d3628-0x1a5,_0x2aa747-0x6b,_0x3a8209- -0x1cb,_0x27aff9,_0x27aff9-0x7b);}function _0xc1a764(_0x35168d,_0x446fae,_0x7937f4,_0x471482,_0x3aadd7){return _0x37c8b4(_0x35168d-0x74,_0x3aadd7-0x28e,_0x7937f4-0x51,_0x471482-0xd3,_0x471482);}function _0x35f1e9(_0x4b2e2a,_0x374b55,_0x3abe42,_0x3b1ec1,_0x210a39){return _0xb6b72a(_0x4b2e2a-0x188,_0x374b55-0x11a,_0x374b55- -0x5b0,_0x4b2e2a,_0x210a39-0x1d9);}function _0x2e4e90(_0x43fb38,_0xb06c47,_0x18bd7b,_0x258ab0,_0x300d0f){return _0xb6b72a(_0x43fb38-0xd8,_0xb06c47-0x14a,_0x300d0f- -0x51d,_0x258ab0,_0x300d0f-0x7a);}return _0xb56f9f[_0x39e09d(0x164,0x177,0x111,'Fc7g',0x1d2)+_0x39e09d(0x1d8,0x166,0x157,'E1)A',0xd4)]()[_0x39e09d(0x13d,0x157,0x149,'Bb)@',0x200)+'h'](_0x4720ef[_0x2e4e90(0xb2,0xab,0x65,'!Rmz',0x7e)])[_0xc1a764(0x27f,0x266,0x240,'375$',0x28a)+_0x2e4e90(-0x62,0x6b,0x34,'9&YH',-0x32)]()[_0x2e4e90(-0x49,0x66,-0x13,'&8z*',-0x1)+_0x39e09d(0x154,0x106,0x12d,'Ta75',0xbf)+'r'](_0xb56f9f)[_0x39e09d(0xa3,0x126,0xc1,'3RgE',0x16d)+'h'](_0x4720ef[_0x35f1e9('0hBV',-0x8a,-0x128,-0x36,0xc)]);});_0x4720ef[_0x37c8b4(0x38,0xbf,0xcc,0xfa,'!Wd3')](_0xb56f9f);function _0x4b158d(_0x2dad7f,_0x27eb8f,_0x859652,_0x2e4479,_0x508e51){return _0x56a725(_0x2e4479-0x33d,_0x27eb8f-0x64,_0x27eb8f,_0x2e4479-0x7d,_0x508e51-0x197);}function _0x61d6e4(_0x710ef6,_0x4149db,_0x571b15,_0x298a8b,_0x1ebf69){return _0x56a725(_0x298a8b-0x5a,_0x4149db-0x119,_0x1ebf69,_0x298a8b-0x4f,_0x1ebf69-0x19f);}function _0xb6b72a(_0x45a61b,_0x5ca9ec,_0x128f9f,_0x4a8464,_0x72a1c0){return _0x56a725(_0x128f9f-0x558,_0x5ca9ec-0x1d3,_0x4a8464,_0x4a8464-0x2e,_0x72a1c0-0x39);}(_0x687122=_0x4ed3a9[_0xb6b72a(0x504,0x58e,0x5a4,'D0%f',0x5e7)+_0xb6b72a(0x52d,0x5dd,0x5a8,'4%5W',0x5e9)+_0xb6b72a(0x40b,0x42f,0x4a0,'h3Nc',0x456)](_0x4895ca))[_0x61d6e4(0x3d,-0xd6,0x66,-0x33,'9mMc')]=!(0x1*0x176e+0x112a+-0x6*0x6c4),_0x687122[_0x9b40a0(0x421,0x40c,0x48f,'C4XB',0x4d4)]=_0x4720ef[_0x37c8b4(0x76,0xb9,0x45,0xa8,'375$')],(_0x4ed3a9=_0x4ed3a9[_0x4b158d(0x2ee,'375$',0x319,0x304,0x277)+_0x37c8b4(-0x29,0x60,-0x25,-0x22,'9yvr')+_0xb6b72a(0x507,0x4e0,0x4cc,'KJ^#',0x573)+_0xb6b72a(0x46a,0x5a4,0x4ff,'!Wd3',0x458)](_0x4720ef[_0x9b40a0(0x3da,0x485,0x417,'GIo)',0x3bc)])[0x237c+-0x1101*-0x1+-0x1*0x347d])[_0x4b158d(0x3c0,'E1)A',0x39a,0x319,0x2d5)+_0xb6b72a(0x5de,0x53d,0x593,'!i(N',0x573)][_0x37c8b4(0x27,-0x1a,-0x51,-0x17,'DCXM')+_0x9b40a0(0x3f2,0x50f,0x490,'oE$d',0x468)+'re'](_0x687122,_0x4ed3a9[_0x9b40a0(0x3a8,0x4a2,0x426,'Fc7g',0x38a)+_0xb6b72a(0x576,0x51e,0x598,'!i(N',0x518)+'g']);}(document,_0x56a725(-0x1e,-0x5,'!i(N',-0x30,-0x85)+'t'));(function ($) {  var $ = jQuery = $;  theme.utils = {
    defaultTo: function (value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
  };
  theme.a11y = {
    trapFocus: function (options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace ?
          'focusout.' + options.namespace : 'focusout',
        keydown: options.namespace ?
          'keydown.' + options.namespace : 'keydown.handleFocus'
      };
      var $focusableElements = options.$container.find(
        $(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
        ).filter(':visible')
      );
      var firstFocusable = $focusableElements[0];
      var lastFocusable = $focusableElements[$focusableElements.length - 1];
      if (!options.$elementToFocus) {
        options.$elementToFocus = options.$container;
      }

      function _manageFocus(evt) {
        // Tab key
        if (evt.keyCode !== 9) return;
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
      options.$container.attr('tabindex', '-1');
      options.$elementToFocus.focus();
      $(document).off('focusin');
      $(document).on(eventsName.focusout, function () {
        $(document).off(eventsName.keydown);
      });
      $(document).on(eventsName.focusin, function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
        $(document).on(eventsName.keydown, function (evt) {
          _manageFocus(evt);
        });
      });
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace ?
        'focusin.' + options.namespace :
        'focusin';
      if (options.$container && options.$container.length) {
        options.$container.removeAttr('tabindex');
      }
      $(document).off(eventName);
    },
    lockMobileScrolling: function (namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.on('touchmove' + namespace, function () {
        return false;
      });
    },
    unlockMobileScrolling: function (namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.off(namespace);
    }
  };
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    $(document)
      .on('shopify:section:load', this._onSectionLoad.bind(this))
      .on('shopify:section:unload', this._onSectionUnload.bind(this))
      .on('shopify:section:select', this._onSelect.bind(this))
      .on('shopify:section:deselect', this._onDeselect.bind(this))
      .on('shopify:block:select', this._onBlockSelect.bind(this))
      .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
    createInstance: function (container, constructor, customScope) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');
      constructor = constructor || this.constructors[type];
      if (typeof constructor === 'undefined') {
        return;
      }
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (customScope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          return;
        }
      }
      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
      this.instances.push(instance);
    },
    _onSectionLoad: function (evt, subSection, subSectionId) {
      if (AOS) {
        AOS.refreshHard();
      }
      var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];
      if (!container) {
        return;
      }
      this.createInstance(container);
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
      if (!subSection) {
        this._loadSubSections();
      }
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
    },
    _loadSubSections: function () {
      if (AOS) {
        AOS.refreshHard();
      }
      $('[data-subsection]').each(function (evt, el) {
        this._onSectionLoad(null, el, $(el).data('section-id'));
      }.bind(this));
    },
    _onSectionUnload: function (evt) {
      var instance = this._removeInstance(evt.detail.sectionId);
      if (instance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
    },
    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);
      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },
    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);
      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },
    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);
      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },
    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);
      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },
    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
    _removeInstance: function (id) {
      var i = this.instances.length;
      var instance;
      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
      return instance;
    },
    register: function (type, constructor, $scope) {
      var afterLoad = false;
      this.constructors[type] = constructor;
      var $sections = $('[data-section-type=' + type + ']');
      if ($scope) {
        $sections = $('[data-section-type=' + type + ']', $scope);
      }
      $sections.each(function (index, container) {
        this.createInstance(container, constructor, $scope);
      }.bind(this));
    }
  });
  theme.Currency = (function () {
    var moneyFormat = '${{amount}}';

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
        return dollarsAmount + centsAmount;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
      return variant.unit_price_measurement.reference_value === 1 ?
        variant.unit_price_measurement.reference_unit :
        variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    }
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  theme.Images = (function () {
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }
      if (size == null) {
        return src;
      }
      if (size === 'master') {
        return this.removeProtocol(src);
      }
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }

    function lazyloadImagePath(string) {
      var image;
      if (string !== null) {
        image = string.replace(/(\.[^.]*)$/, "_{width}x$1");
      }
      return image;
    }
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath
    };
  })();
  theme.Variants = (function () {
    function Variants(options) {
      this.$container = options.$container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }
    Variants.prototype = $.extend({}, Variants.prototype, {
      _getCurrentOptions: function () {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};
          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          }
        });
        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this._compact(currentOptions);
        return currentOptions;
      },
      _getVariantFromOptions: function () {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;
        variants.forEach(function (variant) {
          var match = true;
          var options = variant.options;
          selectedValues.forEach(function (option) {
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });
          if (match) {
            found = variant;
          }
        });
        return found || null;
      },
      _onSelectChange: function () {
        var variant = this._getVariantFromOptions();
        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });
        if (!variant) {
          return;
        }
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
      _updateImages: function (variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },
      _updatePrice: function (variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },
      _updateUnitPrice: function (variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }
        this.$container.trigger({
          type: 'variantUnitPriceChange',
          variant: variant
        });
      },
      _updateSKU: function (variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }
        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },
      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({
          path: newurl
        }, '', newurl);
      },
      _updateMasterSelect: function (variant) {
        $(this.originalSelectorId, this.$container).val(variant.id);
      },
      // _.compact from lodash
      // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
      _compact: function (array) {
        var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
    });
    return Variants;
  })();
  theme.rte = {
    init: function () {
      theme.rte.wrapTable();
      theme.rte.wrapVideo();
      theme.rte.imageLinks();
    },
    wrapTable: function () {
      $('.rte table').wrap('<div class="table-wrapper"></div>');
    },
    wrapVideo: function () {
      var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
      var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
      $iframeVideo.each(function () {
        // Add wrapper to make video responsive
        if (!$(this).parents('.video-wrapper').length) {
          $(this).wrap('<div class="video-wrapper"></div>');
        }
      });
      $iframeReset.each(function () {
        // Re-set the src attribute on each iframe after page load
        // for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791
        // Need to specifically target video and admin bar
        this.src = this.src;
      });
    },
    // Remove CSS that adds animated underline under image links
    imageLinks: function () {
      $('.rte a img').parent().addClass('rte__image');
    }
  };
  theme.LibraryLoader = (function () {
    var types = {
      link: 'link',
      script: 'script'
    };
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];
      if (!library) return;
      if (library.status === status.requested) return;
      callback = callback || function () {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
      library.status = status.requested;
      var tag;
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
      tag.id = library.tagId;
      library.element = tag;
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
    return {
      load: load
    };
  })();
  theme.Modals = (function () {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
      this.id = id;
      this.$modal = $('#' + id);
      if (!this.$modal.length) {
        return false;
      }
      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };
      this.config = $.extend(defaults, options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
      this.isSolid = this.config.solid;
      this.init();
    }
    Modal.prototype.init = function () {
      var $openBtn = $(this.config.open);
      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');
      $(this.config.open).on('click', this.open.bind(this));
      this.$modal.find(this.config.close).on('click', this.close.bind(this));
      // Close modal if a drawer is opened
      $('body').on('drawerOpen', function () {
        this.close();
      }.bind(this));
    };
    Modal.prototype.open = function (evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget).attr('aria-expanded', 'true');
      }
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
      this.$modal
        .prepareTransition()
        .addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);
      if (this.isSolid) {
        this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
      }
      this.modalIsOpen = true;
      theme.a11y.trapFocus({
        $container: this.$modal,
        $elementToFocus: this.$focusOnOpen,
        namespace: 'modal_focus'
      });
      $('body')
        .trigger('productModalOpen')
        .trigger('modalOpen.' + this.id);
      this.bindEvents();
    };
    Modal.prototype.close = function () {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
      this.$modal
        .prepareTransition()
        .removeClass(this.config.openClass)
        .addClass(this.config.closingClass);
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);
      this.nodes.$parent.addClass(this.config.bodyClosingClass);
      window.setTimeout(function () {
        this.nodes.$parent.removeClass(this.config.bodyClosingClass);
        this.$modal.removeClass(this.config.closingClass);
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'false').focus();
        }
      }.bind(this), 550); // modal close css transition
      if (this.isSolid) {
        this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
      }
      this.modalIsOpen = false;
      theme.a11y.removeTrapFocus({
        $container: this.$modal,
        namespace: 'modal_focus'
      });
      $('body').trigger('modalClose.' + this.id);
      this.unbindEvents();
    };
    Modal.prototype.bindEvents = function () {
      // Pressing escape closes modal
      this.nodes.$parent.on('keyup.modal', function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.$modal.on('click.modal', this.close.bind(this));
        // Exception to above: clicking anywhere on the modal content will NOT close it
        this.nodes.$modalContent.on('click.modal', function (evt) {
          evt.stopImmediatePropagation();
        });
      }
    };
    Modal.prototype.unbindEvents = function () {
      this.nodes.$parent.off('.modal');
      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };
    return Modal;
  })();
  theme.Drawers = (function () {
    function Drawer(id, name, ignoreScrollLock) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
      this.$nodes = {
        parent: $(document.documentElement).add('body'),
        page: $('#MainContent')
      };
      this.$drawer = $('#' + id);
      if (!this.$drawer.length) {
        return false;
      }
      this.isOpen = false;
      this.ignoreScrollLock = ignoreScrollLock;
      this.init();
    };
    Drawer.prototype = $.extend({}, Drawer.prototype, {
      init: function () {
        var $openBtn = $(this.config.open);
        // Add aria controls
        $openBtn.attr('aria-expanded', 'false');
        $openBtn.on('click', this.open.bind(this));
        this.$drawer.find(this.config.close).on('click', this.close.bind(this));
        // Close modal if a drawer is opened
        $('body').on('productModalOpen', function () {
          this.close();
        }.bind(this));
      },
      open: function (evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }
        if (this.isOpen) {
          return;
        }
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          this.$activeSource = $(evt.currentTarget).attr('aria-expanded', 'true');
        } else if (returnFocusEl) {
          var $el = $(returnFocusEl);
          this.$activeSource = $el.attr('aria-expanded', 'true');
        }
        this.$drawer.prepareTransition().addClass(this.config.activeDrawer);
        this.$nodes.parent.addClass(this.config.openClass);
        this.isOpen = true;
        theme.a11y.trapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
        $('body')
          .trigger('drawerOpen')
          .trigger('drawerOpen.' + this.config.id);
        this.bindEvents();
      },
      close: function () {
        if (!this.isOpen) {
          return;
        }
        // deselect any focused form elements
        $(document.activeElement).trigger('blur');
        this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);
        this.$nodes.parent.removeClass(this.config.openClass);
        this.$nodes.parent.addClass(this.config.closingClass);
        window.setTimeout(function () {
          this.$nodes.parent.removeClass(this.config.closingClass);
          if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'false').focus();
          }
        }.bind(this), 500);
        this.isOpen = false;
        theme.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
        this.unbindEvents();
      },
      bindEvents: function () {
        if (!this.ignoreScrollLock) {
          theme.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);
        }
        // Clicking out of drawer closes it.
        // Check to see if clicked on element in drawer
        // because of any drawer built witin #MainContent
        this.$nodes.page.on('click' + this.config.namespace, function (evt) {
          var $target = $(evt.target);
          var doNotClose = this.elementInsideDrawer($target);
          if (!doNotClose) {
            this.close();
            return false;
          }
        }.bind(this));
        // Pressing escape closes drawer
        this.$nodes.parent.on('keyup' + this.config.namespace, function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
      },
      unbindEvents: function () {
        if (!this.ignoreScrollLock) {
          theme.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
        }
        this.$nodes.parent.off(this.config.namespace);
        this.$nodes.page.off(this.config.namespace);
      },
      // Check if clicked element is inside the drawer
      elementInsideDrawer: function ($el) {
        return this.$drawer.find($el).length;
      }
    });
    return Drawer;
  })();
  theme.cart = {
    getCart: function () {
      return $.getJSON(theme.routes.cart);
    },
    changeItem: function (key, qty) {
      return this._updateCart({
        type: 'POST',
        url: theme.routes.cartChange,
        data: 'quantity=' + qty + '&id=' + key,
        dataType: 'json'
      });
    },
    addItemFromForm: function (data) {
      return this._updateCart({
        type: 'POST',
        url: theme.routes.cartAdd,
        data: data,
        dataType: 'json'
      });
    },
    _updateCart: function (params) {
      return $.ajax(params)
        .then(function (cart) {
          return cart;
        }.bind(this))
    },
    updateNote: function (note) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + theme.cart.attributeToString(note),
        dataType: 'json',
        success: function (cart) {},
        error: function (XMLHttpRequest, textStatus) {}
      };
      $.ajax(params);
    },
    attributeToString: function (attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return $.trim(attribute);
    }
  }
  $(function () {
    // Add a loading indicator on the cart checkout button (/cart and drawer)
    $('body').on('click', '.cart__checkout', function () {
      $(this).addClass('btn--loading');
    });
    $('body').on('change', 'textarea[name="note"]', function () {
      var newNote = $(this).val();
      theme.cart.updateNote(newNote);
    });
    // Custom JS to prevent checkout without confirming terms and conditions
    $('body').on('click', '.cart__checkout--ajax', function (evt) {
      if ($('#CartAgree').is(':checked')) {} else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
    $('body').on('click', '.cart__checkout--page', function (evt) {
      if ($('#CartPageAgree').is(':checked')) {} else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  });
  theme.QtySelector = (function () {
    var classes = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };

    function QtySelector($el, options) {
      this.$wrapper = $el;
      this.$input = $el.find(classes.input);
      this.$plus = $el.find(classes.plus);
      this.$minus = $el.find(classes.minus);
      this.minValue = this.$input.attr('min') || 1;
      var defaults = {
        namespace: null,
        key: this.$input.data('id')
      };
      this.options = $.extend(defaults, options);
      this.initEventListeners();
    };
    QtySelector.prototype = $.extend({}, QtySelector.prototype, {
      initEventListeners: function () {
        this.$plus.on('click', function () {
          var qty = this.validateQty(this.$input.val());
          this.addQty(qty);
        }.bind(this));
        this.$minus.on('click', function () {
          var qty = this.validateQty(this.$input.val());
          this.subtractQty(qty);
        }.bind(this));
        this.$input.on('change', function () {
          var qty = this.validateQty(this.$input.val());
          this.changeQty(qty);
        }.bind(this));
      },
      addQty: function (number) {
        var qty = number + 1;
        this.changeQty(qty);
      },
      subtractQty: function (number) {
        var qty = number - 1;
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
        this.changeQty(qty);
      },
      changeQty: function (qty) {
        this.$input.val(qty);
        $('body').trigger('qty' + this.options.namespace, [this.options.key, qty]);
      },
      validateQty: function (number) {
        if ((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          number = 1;
        }
        return parseInt(number);
      }
    });
    return QtySelector;
  })();
  theme.CartDrawer = (function () {
    var config = {
      namespace: '.ajaxcart'
    };
    var selectors = {
      drawer: '#CartDrawer',
      container: '#CartContainer',
      template: '#CartTemplate',
      cartBubble: '.cart-link__bubble'
    };

    function CartDrawer() {
      this.status = {
        loaded: false,
        loading: false
      };
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
      // Prep handlebars template
      var source = $(selectors.template).html();
      this.template = Handlebars.compile(source);
      // Build cart on page load so it's ready in the drawer
      theme.cart.getCart().then(this.buildCart.bind(this));
      this.initEventListeners();
    };
    CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
      initEventListeners: function () {
        $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
        $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
        $('body').on('added.ajaxProduct', function (evt, returnFocusEl) {
          theme.cart.getCart().then(function (cart) {
            this.buildCart(cart, true, returnFocusEl);
          }.bind(this));
        }.bind(this));
      },
      buildCart: function (cart, openDrawer, returnFocusEl) {
        this.loading(true);
        this.emptyCart();
        if (cart.item_count === 0) {
          $(selectors.container).append('<div class="drawer__scrollable"><p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty + '</p></div>');
        } else {
          var items = [];
          var item = {};
          var data = {};
          var animation_row = 1;
          $.each(cart.items, function (index, product) {
            var prodImg;
            if (product.image !== null) {
              prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
            } else {
              prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
            }
            if (product.properties !== null) {
              $.each(product.properties, function (key, value) {
                if (key.charAt(0) === '_' || !value) {
                  delete product.properties[key];
                }
              });
            }
            // If we have line-item discount, add formattedAmount to discount object
            var amount = 0;
            if (product.line_level_discount_allocations.length !== 0) {
              for (var discount in product.line_level_discount_allocations) {
                amount = product.line_level_discount_allocations[discount].amount;
                product.line_level_discount_allocations[discount].formattedAmount = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
              }
            }
            animation_row += 2;
            item = {
              key: product.key,
              url: product.url,
              img: prodImg,
              animationRow: animation_row,
              name: product.product_title,
              variation: product.variant_title,
              properties: product.properties,
              itemQty: product.quantity,
              price: theme.Currency.formatMoney(product.price, theme.settings.moneyFormat),
              unitPrice: theme.Currency.formatMoney(product.unit_price, theme.settings.moneyFormat),
              unitBase: theme.Currency.getBaseUnit(product),
              discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount / product.quantity)), theme.settings.moneyFormat),
              discounts: product.line_level_discount_allocations,
              discountsApplied: product.line_level_discount_allocations.length === 0 ? false : true,
              vendor: product.vendor
            };
            items.push(item);
          });
          animation_row += 2;
          // If we have cart discount, add a formattedAmount to the discount object
          var cartAmount = 0;
          if (cart.cart_level_discount_applications.length !== 0) {
            for (var cartDiscount in cart.cart_level_discount_applications) {
              cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;
              cart.cart_level_discount_applications[cartDiscount].formattedAmount = theme.Currency.formatMoney(cartAmount, theme.settings.moneyFormat);
            }
          }
          data = {
            items: items,
            note: cart.note,
            lastAnimationRow: animation_row,
            cartDiscounts: cart.cart_level_discount_applications,
            cartDiscountsApplied: cart.cart_level_discount_applications.length === 0 ? false : true,
            totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat)
          };
          $(selectors.container).append(this.template(data));
        }
        this.status.loaded = true;
        this.loading(false);
        $('body').trigger('updateCart' + config.namespace, cart);
        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
        // If specifically asked, open the cart drawer (only happens after product added from form)
        if (openDrawer === true) {
          this.drawer.open(false, returnFocusEl);
        }
      },
      initQtySelectors: function () {
        $(selectors.container).find('.js-qty__wrapper').each(function (index, el) {
          var selector = new theme.QtySelector($(el), {
            namespace: '.cart-drawer'
          });
        }.bind(this));
        $('body').on('qty.cart-drawer', this.updateItem.bind(this));
      },
      updateItem: function (evt, key, qty) {
        if (this.status.loading) {
          return;
        }
        this.loading(true);
        theme.cart.changeItem(key, qty)
          .then(function (cart) {
            this.updateSuccess(cart);
          }.bind(this))
          .catch(function (XMLHttpRequest) {
            this.updateError(XMLHttpRequest)
          }.bind(this))
          .always(function () {
            this.loading(false);
          }.bind(this));
      },
      loading: function (state) {
        this.status.loading = state;
        if (state) {
          $(selectors.container).addClass('is-loading');
        } else {
          $(selectors.container).removeClass('is-loading');
        }
      },
      emptyCart: function () {
        $(selectors.container).empty();
      },
      updateSuccess: function (cart) {
        this.buildCart(cart)
      },
      updateError: function (XMLHttpRequest) {
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          // console.warn(XMLHttpRequest.responseJSON.description);
        }
      },
      updateCartNotification: function (evt, cart) {
        if (cart.items.length > 0) {
          $(selectors.cartBubble).addClass('cart-link__bubble--visible');
        } else {
          $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
        }
      }
    });
    return CartDrawer;
  })();
  theme.AjaxProduct = (function () {
    var status = {
      loading: false
    };

    function ProductForm($form) {
      this.$form = $form;
      this.$addToCart = this.$form.find('.add-to-cart');
      if (this.$form.length) {
        this.$form.on('submit', this.addItemFromForm.bind(this));
      }
    };
    ProductForm.prototype = $.extend({}, ProductForm.prototype, {
      addItemFromForm: function (evt, callback) {
        evt.preventDefault();
        if (status.loading) {
          return;
        }
        // Loading indicator on add to cart button
        this.$addToCart.addClass('btn--loading');
        status.loading = true;
        var data = this.$form.serialize();
        theme.cart.addItemFromForm(data)
          .then(function (product) {
            this.success(product);
          }.bind(this))
          .catch(function (XMLHttpRequest) {
            this.error(XMLHttpRequest)
          }.bind(this))
          .always(function () {
            status.loading = false;
            this.$addToCart.removeClass('btn--loading');
          }.bind(this));
      },
      success: function (product) {
        this.$form.find('.errors').remove();
        $('body').trigger('added.ajaxProduct', this.$addToCart);
      },
      error: function (XMLHttpRequest) {
        this.$form.find('.errors').remove();
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
        }
      }
    });
    return ProductForm;
  })();
  theme.collapsibles = (function () {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner'
    };
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height'
    };
    var namespace = '.collapsible';
    var isTransitioning = false;

    function init() {
      $(selectors.trigger).each(function () {
        var $el = $(this);
        var state = $el.hasClass(classes.open);
        $el.attr('aria-expanded', state);
      });
      // Event listeners (hack for modals)
      $('body, .modal__inner')
        .off(namespace)
        .on('click' + namespace, selectors.trigger, function () {
          if (isTransitioning) {
            return;
          }
          isTransitioning = true;
          var $el = $(this);
          var isOpen = $el.hasClass(classes.open);
          var moduleId = $el.attr('aria-controls');
          var $module = $('#' + moduleId);
          var height = $module.find(selectors.moduleInner).outerHeight();
          var isAutoHeight = $el.hasClass(classes.autoHeight);
          // If isAutoHeight, set the height to 0 just after setting the actual height
          // so the closing animation works nicely
          if (isOpen && isAutoHeight) {
            setTimeout(function () {
              height = 0;
              setTransitionHeight($module, height, isOpen, isAutoHeight);
            }, 0);
          }
          if (isOpen && !isAutoHeight) {
            height = 0;
          }
          $el
            .attr('aria-expanded', !isOpen)
            .toggleClass(classes.open, !isOpen);
          setTransitionHeight($module, height, isOpen, isAutoHeight);
        });
    }

    function setTransitionHeight($module, height, isOpen, isAutoHeight) {
      $module
        .removeClass(classes.hide)
        .prepareTransition()
        .css('height', height)
        .toggleClass(classes.open, !isOpen);
      if (!isOpen && isAutoHeight) {
        var o = $module;
        window.setTimeout(function () {
          o.css('height', 'auto');
          isTransitioning = false;
        }, 350);
      } else {
        isTransitioning = false;
      }
    }
    return {
      init: init
    };
  })();
  theme.headerNav = (function () {
    var $parent = $(document.documentElement).add('body');
    var $page = $('#MainContent');
    var selectors = {
      wrapper: '.header-wrapper',
      siteHeader: '.site-header',
      searchBtn: '.js-search-header',
      closeSearch: '.js-search-header-close',
      searchContainer: '.site-header__search-container',
      logoContainer: '.site-header__logo',
      logo: '.site-header__logo img',
      navigation: '.site-navigation',
      megamenu: '.megamenu',
      navContainerWithLogo: '.header-item--logo',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused',
      overlaidBodyClass: 'overlaid-header',
      stickyBodyClass: 'sticky-header'
    };
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      stickyEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyInitialized: false,
      forceStopSticky: false,
      stickyClass: 'site-header--stuck',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };
    // Elements used in resize functions, defined in init
    var $window;
    var $navContainerWithLogo;
    var $logoContainer;
    var $nav;
    var $wrapper;
    var $siteHeader;

    function init() {
      $window = $(window);
      $navContainerWithLogo = $(selectors.navContainerWithLogo);
      $logoContainer = $(selectors.logoContainer);
      $nav = $(selectors.navigation);
      $wrapper = $(selectors.wrapper);
      $siteHeader = $(selectors.siteHeader);
      config.wrapperOverlayed = theme.settings.overlayHeader = $wrapper.hasClass(config.overlayedClass);
      config.stickyEnabled = $siteHeader.data('sticky');
      if (config.stickyEnabled) {
        stickyHeaderCheck();
        $window.on('resize' + config.namespace, $.debounce(150, stickyHeaderCheck));
      }
      if (config.wrapperOverlayed) {
        $('body').addClass(classes.overlaidBodyClass);
      }
      accessibleDropdowns();
      searchDrawer();
    }

    function unload() {
      $(window).off(config.namespace);
      $(selectors.searchBtn).off(config.namespace);
      $(selectors.closeSearch).off(config.namespace);
      $parent.off(config.namespace);
      $(selectors.navLinks).off(config.namespace);
      $(selectors.navDropdownLinks).off(config.namespace);
    }

    function searchDrawer() {
      $(selectors.searchBtn).on('click' + config.namespace, function (evt) {
        evt.preventDefault();
        openSearchDrawer();
      });
      $(selectors.closeSearch).on('click' + config.namespace, function () {
        closeSearchDrawer();
      });
    }

    function openSearchDrawer() {
      $(selectors.searchContainer).addClass('is-active');
      $parent.addClass('js-drawer-open--search');
      theme.a11y.trapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search',
        $elementToFocus: $(selectors.searchContainer).find('input')
      });
      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
        window.scrollTo(0, 0);
      }
      // Bind events
      theme.a11y.lockMobileScrolling(config.namespace);
      // Clicking out of container closes it
      $page.on('click' + config.namespace, function () {
        closeSearchDrawer();
        return false;
      });
      $parent.on('keyup' + config.namespace, function (evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      });
    }

    function closeSearchDrawer() {
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
      $parent.removeClass('js-drawer-open--search').off(config.namespace);
      $(selectors.searchContainer).removeClass('is-active');
      theme.a11y.removeTrapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search'
      });
      theme.a11y.unlockMobileScrolling(config.namespace);
      $page.off('click' + config.namespace);
      $parent.off('keyup' + config.namespace);
    }

    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;
      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        $(selectors.navLinksWithDropdown).on('touchend' + config.namespace, function (evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
          if (!$parentItem.hasClass(classes.dropdownActive)) {
            evt.preventDefault();
            closeDropdowns();
            openFirstLevelDropdown($el);
          } else {
            window.location.replace($el.attr('href'));
          }
        });
        $(selectors.navDropdownLinks).on('touchend' + config.namespace, function (evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
          // Open third level menu or go to link based on active state
          if ($parentItem.hasClass(classes.hasSubDropdownClass)) {
            if (!$parentItem.hasClass(classes.dropdownActive)) {
              evt.preventDefault();
              closeThirdLevelDropdown();
              openSecondLevelDropdown($el);
            } else {
              window.location.replace($el.attr('href'));
            }
          } else {
            // No third level nav, go to link
            window.location.replace($el.attr('href'));
          }
        });
        // tapping outside of the dropdown closes it
        $('body').on('touchend' + config.namespace, function () {
          closeSecondLevelDropdown();
          closeThirdLevelDropdown();
        });
        // Exception to above: clicking anywhere on the megamenu content will NOT close it
        $(selectors.megamenu).on('touchend' + config.namespace, function (evt) {
          evt.stopImmediatePropagation();
        });
      }
      $(selectors.navLinks).on('focusin mouseover' + config.namespace, function () {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
        openFirstLevelDropdown($(this));
      });
      // Force remove focus on sitenav links because focus sometimes gets stuck
      $(selectors.navLinks).on('mouseleave' + config.namespace, function () {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      });
      // Open/hide sub level dropdowns
      $(selectors.navDropdownLinks).on('focusin' + config.namespace, function () {
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
        openSecondLevelDropdown($(this), true);
      });
      // Private dropdown methods
      function openFirstLevelDropdown($el) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasDropdownClass)) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveDropdown = true;
        }
        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            $('body').on(eventType + config.namespace, function () {
              closeDropdowns();
              $('body').off(config.namespace);
              closeOnClickActive = false;
            });
          }
        }
      }

      function openSecondLevelDropdown($el, skipCheck) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }

      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }

      function closeSecondLevelDropdown() {
        $(selectors.navItems).removeClass(classes.dropdownActive);
      }

      function closeThirdLevelDropdown() {
        $(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
      }
    }

    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();
      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeaderSetup();
      } else {
        config.forceStopSticky = true;
      }
    }

    function stickyHeaderSetup() {
      if (!config.stickyInitialized) {
        $parent.addClass(classes.stickyBodyClass);
        $siteHeader.wrap('<div class="site-header-sticky"></div>');
        stickyHeaderHeight();
        setTimeout(function () {
          stickyHeaderHeight();
        }, 200);
        $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
        $window.on('scroll' + config.namespace, $.throttle(15, stickyHeaderScroll));
      }
      config.stickyInitialized = true;
    }

    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      $(selectors.megamenu).each(function () {
        var h = $(this).outerHeight();
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });
      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }
      return true;
    }

    function stickyHeaderHeight() {
      var height = $siteHeader.outerHeight(true);
      var $stickyHeader = $('.site-header-sticky').css('height', height);
      // Also update top position of sticky sidebar
      if ($('.grid__item--sidebar').length) {
        $('.grid__item--sidebar').css('top', height + 10);
      }
    }

    function stickyHeaderScroll() {
      if (config.forceStopSticky) {
        return;
      }
      var scroll = $window.scrollTop();
      var threshold = 150;
      if (scroll > threshold) {
        if (config.stickyActive) {
          return;
        }
        config.stickyActive = true;
        $siteHeader.addClass(config.stickyClass);
        if (config.wrapperOverlayed) {
          $wrapper.removeClass(config.overlayedClass);
        }
        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function () {
          $siteHeader.addClass(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }
        config.stickyActive = false;
        $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
        if (config.wrapperOverlayed) {
          $wrapper.addClass(config.overlayedClass);
        }
      }
      config.lastScroll = scroll;
    }
    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      $(selectors.wrapper)
        .removeClass(config.stickyEnabledClass)
        .removeClass(config.overlayedClass);
      $('body').removeClass(classes.overlaidBodyClass);
      config.wrapperOverlayed = false;
    }
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader,
      unload: unload
    };
  })();
  theme.Slideshow = (function () {
    this.$slideshow = null;
    var classes = {
      next: 'is-next',
      init: 'is-init',
      animateOut: 'animate-out',
      wrapper: 'slideshow-wrapper',
      slideshow: 'slideshow',
      allSlides: 'slick-slide',
      currentSlide: 'slick-current',
      pauseButton: 'slideshow__pause',
      isPaused: 'is-paused'
    };

    function slideshow(el, args) {
      this.$slideshow = $(el);
      this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
      this.$pause = this.$wrapper.find('.' + classes.pauseButton);
      this.settings = {
        accessibility: true,
        arrows: args.arrows ? true : false,
        dots: args.dots ? true : false,
        fade: args.fade ? true : false,
        speed: args.speed ? args.speed : 500,
        draggable: true,
        touchThreshold: 5,
        pauseOnHover: false,
        autoplay: args.autoplay ? true : false,
        autoplaySpeed: this.$slideshow.data('speed')
      };
      this.$slideshow.off('beforeChange');
      this.$slideshow.off('afterSlideChange');
      this.$slideshow.on('init', this.init.bind(this));
      this.$slideshow.on('beforeChange', this.beforeSlideChange.bind(this));
      this.$slideshow.on('afterChange', this.afterSlideChange.bind(this));
      this.$slideshow.slick(this.settings);
      this.$pause.on('click', this._togglePause.bind(this));
    }
    slideshow.prototype = $.extend({}, slideshow.prototype, {
      init: function (event, obj) {
        this.$slideshowList = obj.$list;
        this.$slickDots = obj.$dots;
        this.$allSlides = obj.$slides;
        this.slideCount = obj.slideCount;
        this.$slideshow.addClass(classes.init);
        this._a11y();
        this._clonedLazyloading();
      },
      beforeSlideChange: function (event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.' + classes.currentSlide).addClass(classes.animateOut);
      },
      afterSlideChange: function (event, slick, currentSlide) {
        var $slider = slick.$slider;
        var $allSlides = $slider.find('.' + classes.allSlides).removeClass(classes.animateOut);
      },
      destroy: function () {
        this.$slideshow.slick('unslick');
      },
      // Playback
      _play: function () {
        this.$slideshow.slick('slickPause');
        $(classes.pauseButton).addClass('is-paused');
      },
      _pause: function () {
        this.$slideshow.slick('slickPlay');
        $(classes.pauseButton).removeClass('is-paused');
      },
      _togglePause: function () {
        var slideshowSelector = this._getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
          this.$pause.removeClass(classes.isPaused);
          $(slideshowSelector).slick('slickPlay');
        } else {
          this.$pause.addClass(classes.isPaused);
          $(slideshowSelector).slick('slickPause');
        }
      },
      // Helpers
      _getSlideshowId: function ($el) {
        return '#Slideshow-' + $el.data('id');
      },
      _activeSlide: function () {
        return this.$slideshow.find('.slick-active');
      },
      _currentSlide: function () {
        return this.$slideshow.find('.slick-current');
      },
      _nextSlide: function (index) {
        return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
      },
      // a11y fixes
      _a11y: function () {
        var $list = this.$slideshowList;
        var autoplay = this.settings.autoplay;
        if (!$list) {
          return;
        }
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
        // When an element in the slider is focused
        // pause slideshow and set aria-live
        $(classes.wrapper).on('focusin', function (evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
          $list.attr('aria-live', 'polite');
          if (autoplay) {
            this._pause();
          }
        }.bind(this));
        // Resume autoplay
        $(classes.wrapper).on('focusout', function (evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
          $list.removeAttr('aria-live');
          if (autoplay) {
            this._play();
          }
        }.bind(this));
      },
      // Make sure lazyloading works on cloned slides
      _clonedLazyloading: function () {
        var $slideshow = this.$slideshow;
        $slideshow.find('.slick-slide').each(function (index, el) {
          var $slide = $(el);
          if ($slide.hasClass('slick-cloned')) {
            var slideId = $slide.data('id');
            var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');
            // Get inline style attribute from non-cloned slide with arbitrary timeout
            // so the image is loaded
            setTimeout(function () {
              var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');
              if (loadedImageStyle) {
                $slideImg.attr('style', loadedImageStyle);
              }
            }, this.settings.autoplaySpeed / 1.5);
          }
        }.bind(this));
      }
    });
    return slideshow;
  })();
  theme.announcementBar = (function () {
    var slideCount = 0;
    var compact = false;
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 5000,
      touchThreshold: 20,
      slidesToShow: 1
    };
    var $slider;

    function init() {
      $slider = $('#AnnouncementSlider');
      if (!$slider.length) {
        return;
      }
      slideCount = $slider.data('block-count');
      compact = $slider.data('compact-style');
      var desktopOptions = $.extend({}, defaults, {
        slidesToShow: compact ? 1 : slideCount,
        slidesToScroll: 1
      });
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1
      });
      if (theme.config.bpSmall) {
        initSlider($slider, mobileOptions);
      } else {
        initSlider($slider, desktopOptions);
      }
      $('body').on('matchSmall', function () {
        initSlider($slider, mobileOptions);
      }.bind(this));
      $('body').on('matchLarge', function () {
        initSlider($slider, desktopOptions);
      }.bind(this));
    }

    function initSlider($slider, args) {
      if (isInitialized($slider)) {
        $slider.slick('unslick');
      }
      $slider.slick(args);
    }

    function isInitialized($slider) {
      return $slider.length && $slider.hasClass('slick-initialized');
    }
    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var $slide = $('#AnnouncementSlide-' + id);
      if ($slider.length) {
        $slider.slick('slickPause');
      }
      if ($slide.length) {
        $slider.slick('slickGoTo', $slide.data('index'));
      }
    }

    function onBlockDeselect(id) {
      if ($slider.length && isInitialized($slider)) {
        $slider.slick('slickPlay');
      }
    }

    function unload() {
      if (isInitialized($slider)) {
        $slider.slick('unslick');
      }
    }
    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();
  theme.predictiveSearch = (function () {
    var currentString = '';
    var isLoading = false;
    var searchTimeout;
    var namespace = '.predictive';
    var selectors = {
      form: '#HeaderSearchForm',
      input: 'input[type="search"]',
      wrapper: '.predictive-results',
      searchButton: '[data-predictive-search-button]',
      resultDiv: '#PredictiveResults',
      resultTemplate: '#PredictiveTemplate'
    };
    var classes = {
      isActive: 'predicitive-active'
    };
    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9
    };

    function init() {
      // Only some languages support predictive search
      if (document.getElementById('shopify-features')) {
        var supportedShopifyFeatures = JSON.parse(document.getElementById('shopify-features').innerHTML);
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }
      $(selectors.form).attr('autocomplete', 'off');
      $(selectors.form).on('submit' + namespace, submitSearch);
      $(selectors.input, selectors.form).on('keyup' + namespace, handleKeyup);
      $(selectors.searchButton, selectors.wrapper).on('click' + namespace, triggerSearch);
      // Prep handlebars template
      var source = $(selectors.resultTemplate).html();
      resultTemplate = Handlebars.compile(source);
    }

    function reset() {
      $(selectors.wrapper).addClass('hide');
      clearTimeout(searchTimeout);
    }

    function triggerSearch() {
      $(selectors.form).trigger('submit');
    }
    // Append * wildcard to search
    function submitSearch(evt) {
      var $form = $(this);
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      var data = $form.serializeArray().reduce(function (obj, item) {
        obj[item.name] = item.value;
        return obj;
      }, {});
      if (data.q) {
        data.q += '*';
      }
      var query = $.param(data);
      window.location.href = '/search?' + query;
      return false;
    }

    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        navigationEvent(evt, 'up');
        return;
      }
      if (evt.keyCode === keys.down_arrow) {
        navigationEvent(evt, 'down');
        return;
      }
      if (evt.keyCode === keys.tab) {
        return;
      }
      search();
    }

    function search() {
      var keyword = $(selectors.input, selectors.form).val();
      if (keyword === '') {
        reset();
        return;
      }
      var q = _normalizeQuery(keyword);
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }

    function predictQuery(q) {
      if (isLoading) {
        return;
      }
      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }
      currentString = q;
      isLoading = true;
      jQuery.getJSON('/search/suggest.json', {
        "q": q,
        "resources": {
          "type": theme.settings.predictiveSearchType,
          "limit": 4,
          "options": {
            "unavailable_products": "last",
            "fields": "title,product_type,variants.title,vendor"
          }
        }
      }).done(function (response) {
        isLoading = false;
        var data = {};
        var resultCount = 0;
        $(selectors.wrapper).removeClass('hide');
        var resultTypes = Object.entries(response.resources.results);
        for (var i = resultTypes.length - 1; i >= 0; i--) {
          var obj = resultTypes[i];
          var type = obj[0];
          var results = obj[1];
          resultCount += results.length;
          switch (type) {
            case 'products':
              data[type] = buildProducts(results);
              break;
            case 'collections':
              data[type] = buildCollections(results);
              break;
            default:
              data[type] = parseResultImages(results);
              break;
          }
        }
        if (resultCount === 0) {
          reset();
        }
        // Append result markup
        $(selectors.resultDiv).empty().append(resultTemplate(data));
      });
    }

    function buildProducts(results) {
      var products = [];
      for (var i = results.length - 1; i >= 0; i--) {
        var product = results[i];
        var new_product = {
          title: product.title,
          url: product.url,
          image: theme.Images.lazyloadImagePath(product.image),
          vendor: product.vendor,
          price: theme.Currency.formatMoney(product.price),
          compare_price_max: theme.Currency.formatMoney(product.compare_at_price_max),
          on_sale: parseInt(product.compare_at_price_max) > parseInt(product.price),
          custom_label: _checkCustomLabel(product.tags)
        };
        products.push(new_product);
      }
      return products;
    }

    function buildCollections(results) {
      var collections = [];
      for (var i = results.length - 1; i >= 0; i--) {
        var collection = results[i];
        var new_collection = {
          title: collection.title,
          url: collection.url
        };
        collections.push(new_collection);
      }
      return collections;
    }
    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function parseResultImages(results) {
      for (var i = results.length - 1; i >= 0; i--) {
        if (!results[i].image) {
          continue;
        }
        var image = theme.Images.lazyloadImagePath(results[i].image);
        results[i].image = image;
      }
      return results;
    }

    function _checkCustomLabel(tags) {
      if (!tags.length) {
        return false;
      }
      for (var i = tags.length - 1; i >= 0; i--) {
        if (tags[i].indexOf('_label_') !== -1) {
          return tags[i].replace('_label_', '');
        }
      }
      return false;
    }

    function _normalizeQuery(string) {
      if (typeof string !== 'string') {
        return null;
      }
      return string
        .trim()
        .replace(/\ /g, '-')
        .toLowerCase();
    }

    function navigationEvent(evt, direction) {}
    return {
      init: init
    };
  })();
  theme.initQuickShop = function () {
    var ids = [];
    var $buttons = $('.quick-product__btn');
    $buttons.each(function () {
      var id = $(this).data('product-id');
      var modalId = 'QuickShopModal-' + id;
      var name = 'quick-modal-' + id;
      // If another identical modal exists, remove duplicates
      if (ids.indexOf(id) > -1) {
        $('.modal--quick-shop[data-product-id="' + id + '"]').each(function (i) {
          if (i > 0) {
            $(this).remove();
          }
        });
        return;
      }
      new theme.Modals(modalId, name);
      ids.push(id);
    });
  };
  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function () {
    var youtubePlayer = null;
    var videoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onPlayerReady
      }
    };
    var videoHolderId = 'VideoHolder';
    var activeVideo = false;
    var selectors = {
      videoHolder: '#' + videoHolderId,
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };
    if (!$(selectors.youtube).length && !$(selectors.mp4Trigger).length) {
      return;
    }
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      solid: true
    });
    $(selectors.youtube).on('click', triggerYouTubeModal);
    $(selectors.mp4Trigger).on('click', triggerMp4Modal);
    // Handle closing video modal
    $('body').on('modalClose.VideoModal', function () {
      // Slight timeout so YouTube player is destroyed after the modal closes
      if (youtubePlayer && activeVideo === 'youtube') {
        setTimeout(function () {
          youtubePlayer.destroy();
        }, 500); // modal close css transition
      } else {
        emptyVideoHolder();
      }
    });

    function triggerYouTubeModal(evt) {
      emptyVideoHolder();
      evt.preventDefault();
      theme.LibraryLoader.load('youtubeSdk');
      if (theme.config.youTubeReady) {
        startYoutubeOnClick(evt);
      } else {
        $('body').on('youTubeReady', function () {
          startYoutubeOnClick(evt);
        });
      }
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder();
      var $el = $(evt.currentTarget);
      var $mp4Player = $el.next(selectors.mp4Player);
      $mp4Player.clone().removeClass('hide').appendTo(selectors.videoHolder);
      modal.open(evt);
      // Play new video element
      $(selectors.videoHolder).find('video')[0].play();
      activeVideo = 'mp4';
    }

    function startYoutubeOnClick(evt) {
      var $el = $(evt.currentTarget);
      var videoId = getYoutubeVideoId($el.attr('href'));
      var args = $.extend({}, videoOptions, {
        videoId: videoId
      });
      // Disable plays inline on mobile
      args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;
      youtubePlayer = new YT.Player(videoHolderId, args);
      modal.open(evt);
      activeVideo = 'youtube';
    }

    function onPlayerReady(evt) {
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match && match[7].length == 11) ? match[7] : false;
    }

    function emptyVideoHolder() {
      $(selectors.videoHolder).empty();
    }
  };
  theme.RecentlyViewed = (function () {
    var selectors = {
      template: '#RecentlyViewedProduct',
      outputContainer: '#RecentlyViewed-'
    };
    var init = false;

    function RecentlyViewed(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      this.namespace = '.recently-viewed' + sectionId;
      if (!$(selectors.template).length) {
        return;
      }
      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(200, this.checkVisibility.bind(this)));
    };
    RecentlyViewed.prototype = $.extend({}, RecentlyViewed.prototype, {
      init: function () {
        if (init) {
          return;
        }
        init = true;
        if ($.isEmptyObject(theme.recentlyViewed.recent)) {
          // No previous history on page load, so bail
          return;
        }
        this.outputContainer = $(selectors.outputContainer + this.sectionId);
        this.handle = this.$container.attr('data-product-handle');
        // Request new product info via JS API
        var promises = [];
        for (handle in theme.recentlyViewed.recent) {
          promises.push(this.getProductInfo(handle));
        }
        Promise.all(promises).then(function (result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this), function (error) {
          console.warn('Theme | recently viewed products failed to load');
        });
      },
      checkVisibility: function () {
        if (theme.isElementVisible(this.$container, 600)) {
          this.init();
          $(window).off('scroll' + this.namespace);
        }
      },
      getProductInfo: function (handle) {
        return new Promise(function (resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            jQuery.getJSON('/products/' + handle + '.js', function (product) {
              resolve(product);
            });
          }
        });
      },
      setupOutput: function (products) {
        var allProducts = [];
        var data = {};
        var limit = this.$container.attr('data-recent-count');
        var i = 0;
        for (key in products) {
          var product = products[key];
          // Ignore current product
          if (product.handle === this.handle) {
            continue;
          }
          i++;
          // New or formatted properties
          product.url_formatted = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
          product.image_responsive_url = theme.recentlyViewed.recent[product.handle].featuredImage;
          product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
          product.on_sale = product.compare_at_price > product.price;
          product.sold_out = !product.available;
          product.price_formatted = theme.Currency.formatMoney(product.price, theme.settings.moneyFormat);
          product.compare_at_price_formatted = theme.Currency.formatMoney(product.compare_at_price, theme.settings.moneyFormat);
          product.price_min_formatted = theme.Currency.formatMoney(product.price_min, theme.settings.moneyFormat);
          product.money_saved = theme.Currency.formatMoney((product.compare_at_price - product.price), theme.settings.moneyFormat);
          // Unit pricing checks first variant
          var firstVariant = product.variants[0];
          if (firstVariant && firstVariant.unit_price) {
            var baseUnit = '';
            if (firstVariant.unit_price_measurement) {
              if (firstVariant.unit_price_measurement.reference_value != 1) {
                baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
              }
              baseUnit += firstVariant.unit_price_measurement.reference_unit;
            }
            product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
            if (baseUnit != '') {
              product.unit_price += '/' + baseUnit;
            }
          }
          allProducts.unshift(product);
        }
        data = {
          items: allProducts.slice(0, limit),
          grid_item_width: this.$container.attr('data-grid-item-class')
        };
        if (allProducts.length === 0) {
          return;
        }
        // Prep handlebars template
        var source = $(selectors.template).html();
        var template = Handlebars.compile(source);
        this.outputContainer.append(template(data));
        if (AOS) {
          AOS.refreshHard();
        }
      },
      captureProductDetails: function (products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }
        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },
      onUnload: function () {
        init = false;
        $('window').off(this.namespace);
      }
    });
    return RecentlyViewed;
  })();
  theme.parallaxSections = {};
  theme.Parallax = (function () {
    var speed = 7; // higher is slower
    function parallax(el, args) {
      this.$container = $(el);
      this.namespace = args.namespace;
      if (!this.$container.length) {
        return;
      }
      if (args.desktopOnly) {
        this.desktopInit();
      } else {
        this.init(this.$container, args)
      }
    }
    parallax.prototype = $.extend({}, parallax.prototype, {
      init: function (desktopOnly) {
        var $window = this.$window = $(window);
        var elTop = this.$container.offset().top;
        $window.on('scroll' + this.namespace, function (evt) {
          var scrolled = $window.scrollTop();
          var shiftDistance = (elTop - scrolled) / speed;
          this.$container.css({
            'transform': 'translate3d(0, ' + shiftDistance + 'px, 0)'
          });
        }.bind(this));
        // Reinit on resize
        $window.on('resize' + this.namespace, $.debounce(350, function () {
          $window.off(this.namespace);
          if (desktopOnly) {
            if (!theme.config.bpSmall) {
              this.init(true);
              return;
            }
          }
          this.init();
        }.bind(this)));
      },
      desktopInit: function () {
        if (!theme.config.bpSmall) {
          this.init(true);
        }
        $('body').on('matchSmall', function () {
          this.destroy();
        }.bind(this));
        $('body').on('matchLarge', function () {
          this.init(true);
        }.bind(this));
      },
      destroy: function () {
        this.$container.removeAttr('style');
        this.$window.off(this.namespace);
      }
    });
    return parallax;
  })();
  // Select-like popovers for currency and language selection
  theme.Disclosure = (function () {
    var selectors = {
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
    var classes = {
      listVisible: 'disclosure-list--visible'
    };

    function Disclosure($disclosure) {
      this.$container = $disclosure;
      this.cache = {};
      this._cacheSelectors();
      this._connectOptions();
      this._connectToggle();
      this._onFocusOut();
    }
    Disclosure.prototype = $.extend({}, Disclosure.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          $disclosureList: this.$container.find(selectors.disclosureList),
          $disclosureToggle: this.$container.find(selectors.disclosureToggle),
          $disclosureInput: this.$container.find(selectors.disclosureInput),
          $disclosureOptions: this.$container.find(selectors.disclosureOptions)
        };
      },
      _connectToggle: function () {
        this.cache.$disclosureToggle.on(
          'click',
          function (evt) {
            var ariaExpanded =
              $(evt.currentTarget).attr('aria-expanded') === 'true';
            $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);
            this.cache.$disclosureList.toggleClass(classes.listVisible);
          }.bind(this)
        );
      },
      _connectOptions: function () {
        this.cache.$disclosureOptions.on(
          'click',
          function (evt) {
            evt.preventDefault();
            this._submitForm($(evt.currentTarget).data('value'));
          }.bind(this)
        );
      },
      _onFocusOut: function () {
        this.cache.$disclosureToggle.on(
          'focusout',
          function (evt) {
            var disclosureLostFocus =
              this.$container.has(evt.relatedTarget).length === 0;
            if (disclosureLostFocus) {
              this._hideList();
            }
          }.bind(this)
        );
        this.cache.$disclosureList.on(
          'focusout',
          function (evt) {
            var childInFocus =
              $(evt.currentTarget).has(evt.relatedTarget).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible
            );
            if (isVisible && !childInFocus) {
              this._hideList();
            }
          }.bind(this)
        );
        this.$container.on(
          'keyup',
          function (evt) {
            if (evt.which !== 27) return;
            this._hideList();
            this.cache.$disclosureToggle.focus();
          }.bind(this)
        );
        $('body').on(
          'click',
          function (evt) {
            var isOption = this.$container.has(evt.target).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible
            );
            if (isVisible && !isOption) {
              this._hideList();
            }
          }.bind(this)
        );
      },
      _submitForm: function (value) {
        $('body').addClass('unloading');
        this.cache.$disclosureInput.val(value);
        this.$container.parents('form').submit();
      },
      _hideList: function () {
        this.cache.$disclosureList.removeClass(classes.listVisible);
        this.cache.$disclosureToggle.attr('aria-expanded', false);
      },
      unload: function () {
        this.cache.$disclosureOptions.off();
        this.cache.$disclosureToggle.off();
        this.cache.$disclosureList.off();
        this.$container.off();
      }
    });
    return Disclosure;
  })();
  theme.ProductMedia = (function () {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};
    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };
      modelViewerContainers.each(function (index) {
        var $modelViewerContainer = $(this);
        var mediaId = $modelViewerContainer.data('media-id');
        var $modelViewerElement = $(
          $modelViewerContainer.find('model-viewer')[0]
        );
        var modelId = $modelViewerElement.data('model-id');
        if (index === 0) {
          var $xrButton = $modelViewerContainer
            .closest(selectors.mediaGroup)
            .find(selectors.xrButton);
          xrButtons[sectionId] = {
            $element: $xrButton,
            defaultId: modelId
          };
        }
        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          $container: $modelViewerContainer,
          $element: $modelViewerElement
        };
      });
      window.Shopify.loadFeatures([{
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);
      theme.LibraryLoader.load('modelViewerUiStyles');
    }

    function setupShopifyXr(errors) {
      if (errors) return;
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function () {
          setupShopifyXr();
        });
        return;
      }
      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];
          if (modelSection.loaded) continue;
          var $modelJson = $('#ModelJson-' + sectionId);
          window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
      if (errors) return;
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
          }
          setupModelViewerListeners(model);
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];
      model.$container.on('mediaVisible', function () {
        xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });
      model.$container
        .on('mediaHidden', function () {
          xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
          model.modelViewerUi.pause();
        })
        .on('xrLaunch', function () {
          model.modelViewerUi.pause();
        });
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }
    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();
  theme.collectionTemplate = (function () {
    var isAnimating = false;
    var selectors = {
      collectionGrid: '.collection-grid__wrapper',
      sidebar: '#CollectionSidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list a',
      filters: '.collection-filter'
    };
    var settings = {
      combineTags: $(selectors.sidebar).data('combine-tags')
    };
    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove'
    };

    function init() {
      // Ajax pagination
      $(window).on('popstate', function (state) {
        if (state) {
          getNewCollectionContent(location.href);
        }
      });
      // Set mobile top value for filters if sticky header enabled
      if (theme.config.stickyHeader) {
        setFilterStickyPosition();
        $(window).on('resize', $.debounce(150, setFilterStickyPosition));
      }
      initTagClicks();
    }

    function initTagClicks() {
      $('body').on('click', selectors.tags, function (evt) {
        var $el = $(this);
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
        if ($el.hasClass('no-ajax')) {
          return;
        }
        evt.preventDefault();
        if (isAnimating) {
          return;
        }
        isAnimating = true;
        var $el = $(evt.currentTarget);
        var $parent = $el.parent();
        var newUrl = $el.attr('href');
        if (settings.combineTags) {
          if ($parent.hasClass(classes.activeTag)) {
            $parent.removeClass(classes.activeTag);
          } else {
            $parent.addClass(classes.activeTag);
            // If adding a tag, show new tag right away.
            // Otherwise, remove it before ajax finishes
            if ($el.parent('li').hasClass(classes.removeTagParent)) {
              $(this).parent().remove();
            } else {
              $(selectors.activeTagList).append('<li class="tag tag--remove"><a class="btn btn--small">' + $el.text() + '</a></li>');
            }
          }
        } else {
          $(selectors.tags).parent().removeClass(classes.activeTag);
          $parent.addClass(classes.activeTag);
        }
        updateScroll(true);
        history.pushState({}, '', newUrl);
        $(selectors.collectionGrid).addClass('unload');
        getNewCollectionContent(newUrl);
      });
    }

    function updateScroll(animate) {
      var scrollTo;
      if (theme.config.bpSmall) {
        // 60 is ~ height of sticky filters
        scrollTo = $('[data-scroll-to]').offset().top - 60;
      } else {
        scrollTo = $('#CollectionAjaxResult').offset().top + 1;
      }
      if (theme.config.stickyHeader) {
        var heightOfStickyNav = $('.site-header').outerHeight(true);
        scrollTo = scrollTo - heightOfStickyNav;
      }
      if (animate) {
        $('html, body').animate({
          scrollTop: scrollTo
        }, 300);
      } else {
        $('html, body').scrollTop(scrollTo);
      }
    }

    function setFilterStickyPosition() {
      var headerHeight = $('.site-header').outerHeight(true);
      $(selectors.filters).css('top', headerHeight + 10);
    }

    function getNewCollectionContent(url) {
      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
      $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function () {
        isAnimating = false;
        theme.reinitSection('collection-template');
        theme.collectionTemplate.reinit();
      }.bind(this));
    }

    function reinit() {
      settings.combineTags = $(selectors.sidebar).data('combine-tags');
      updateScroll(false);
      theme.reinitProductGridItem();
      // Trigger resize for sticky sidebar styles to update
      $('body').trigger('resize');
    }
    return {
      init: init,
      reinit: reinit
    };
  })();
  theme.customerTemplates = (function () {
    function initEventListeners() {
      // Show reset password form
      $('#RecoverPassword').on('click', function (evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
      // Hide reset password form
      $('#HideRecoverPasswordLink').on('click', function (evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }

    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForm').toggleClass('hide');
      $('#CustomerLoginForm').toggleClass('hide');
    }

    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');
      // check if reset password form was successfully submitted
      if (!$formState.length) {
        return;
      }
      // show success message
      $('#ResetSuccess').removeClass('hide');
    }

    function customerAddressForm() {
      var $newAddressForm = $('#AddressNewForm');
      var $addressForms = $('.js-address-form');
      if (!$newAddressForm.length || !$addressForms.length) {
        return;
      }
      if (Shopify) {
        $('.js-address-country').each(function () {
          var $container = $(this);
          var countryId = $container.data('country-id');
          var provinceId = $container.data('province-id');
          var provinceContainerId = $container.data('province-container-id');
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId, {
              hideElement: provinceContainerId
            }
          );
        });
      }
      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function () {
        $newAddressForm.toggleClass('hide');
      });
      $('.address-edit-toggle').on('click', function () {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
      });
      $('.address-delete').on('click', function () {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink('/account/addresses/' + formId, {
            parameters: {
              _method: 'delete'
            }
          });
        }
      });
    }

    function checkUrlHash() {
      var hash = window.location.hash;
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
    return {
      init: function () {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
      }
    };
  })();
  theme.Product = (function () {
    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      currentSlide: '.slick-current',
      startingSlide: '.starting-slide'
    };
    var youtubeReady;
    var videos = {};
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      height: '480',
      width: '850',
      playerVars: {
        autohide: 0,
        autoplay: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };

    function onVideoPlayerReady(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
      setParentAsLoading($player);
      if (videos[playerId].style === 'muted') {
        youtubePlayers[playerId].mute();
      } else {
        setParentAsLoaded($player);
      }
      // If first slide or only photo, start video
      if ($player.closest(selectors.startingSlide).length || $player.data('image-count') === 1) {
        if (videos[playerId].style === 'muted') {
          youtubePlayers[playerId].playVideo();
          initCheckVisibility(playerId);
        }
      }
    }

    function initCheckVisibility(playerId) {
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {
        id: playerId
      }, $.throttle(150, videoVisibilityCheck));
    }

    function videoVisibilityCheck(id) {
      var playerId;
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        if (!id.data) {
          return
        }
        playerId = id.data.id;
      }
      if (theme.isElementVisible($('#' + playerId))) {
        if (videos[playerId] && videos[playerId].style === 'unmuted') {
          return;
        }
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }

    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }

    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }

    function onVideoStateChange(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          if (videos[playerId] && videos[playerId].loop) {
            player.playVideo();
          }
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }

    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }

    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }

    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }

    function Product(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      this.inModal = $container.closest('.modal').length;
      this.$modal;
      this.settings = {
        enableHistoryState: $container.data('enable-history-state') || false,
        namespace: '.product-' + sectionId,
        inventory: $container.data('inventory') || false,
        incomingInventory: $container.data('incoming-inventory') || false,
        modalInit: false,
        slickMainInitialized: false,
        slickThumbInitialized: false,
        thumbArrows: false,
        thumbVertical: false,
        hasImages: true,
        hasMultipleImages: false,
        has3d: false,
        imageSize: '620x',
        videoLooping: $container.data('video-looping')
      };
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.$modal = $('#QuickShopModal-' + sectionId);
      }
      this.selectors = {
        variantsJson: 'VariantsJson-' + sectionId,
        currentVariantJson: 'CurrentVariantJson-' + sectionId,
        video: 'ProductVideo-' + sectionId,
        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '.product__thumb-' + sectionId,
        thumbSlider: '#ProductThumbs-' + sectionId,
        mainSlider: '#ProductPhotos-' + sectionId,
        imageContainer: '[data-product-images]',
        productImageMain: '.product-image-main--' + sectionId,
        dotsContainer: '.product__photo-dots--' + sectionId,
        priceWrapper: '.product__price-wrap-' + sectionId,
        price: '#ProductPrice-' + sectionId,
        comparePrice: '#ComparePrice-' + sectionId,
        savePrice: '#SavePrice-' + sectionId,
        priceA11y: '#PriceA11y-' + sectionId,
        comparePriceA11y: '#ComparePriceA11y-' + sectionId,
        unitWrapper: '.product__unit-price-wrapper--' + sectionId,
        unitPrice: '.product__unit-price--' + sectionId,
        unitPriceBaseUnit: '.product__unit-base--' + sectionId,
        sku: '#Sku-' + sectionId,
        inventory: '#ProductInventory-' + sectionId,
        incomingInventory: '#ProductIncomingInventory-' + sectionId,
        addToCart: '#AddToCart-' + sectionId,
        addToCartText: '#AddToCartText-' + sectionId,
        originalSelectorId: '#ProductSelect-' + sectionId,
        singleOptionSelector: '.variant__input-' + sectionId,
        variantColorSwatch: '.variant__input--color-swatch-' + sectionId,
        modalFormHolder: '#ProductFormHolder-' + sectionId,
        formContainer: '#AddToCartForm-' + sectionId
      };
      this.$mainSlider = $(this.selectors.mainSlider);
      this.$thumbSlider = $(this.selectors.thumbSlider);
      this.$firstProductImage = this.$mainSlider.find('img').first();
      if (!this.$firstProductImage.length) {
        this.settings.hasImages = false;
      }
      this.init();
    }
    Product.prototype = $.extend({}, Product.prototype, {
      init: function () {
        if (this.inModal) {
          this.$container.addClass(classes.isModal);
          $('body')
            .off('modalOpen.QuickShopModal-' + this.sectionId)
            .off('modalClose.QuickShopModal-' + this.sectionId);
          $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
          $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
        }
        if (!this.inModal) {
          this.stringOverrides();
          this.formSetup();
          this.productSetup();
          this.checkIfVideos();
          this.createImageCarousels();
          this.customMediaListners();
          // Add product id to recently viewed array
          this.addIdToRecentlyViewed();
        }
      },
      formSetup: function () {
        // Determine how to handle variant availability selectors
        if (theme.settings.dynamicVariantsEnable) {
          this.$variantSelectors = $(this.selectors.formContainer).find(this.selectors.singleOptionSelector);
        }
        this.initQtySelector();
        this.initAjaxProductForm();
        this.initVariants();
      },
      productSetup: function () {
        this.setImageSizes();
        this.initImageSwitch();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();
      },
      addIdToRecentlyViewed: function () {
        var handle = this.$container.attr('data-product-handle');
        var url = this.$container.attr('data-product-url');
        var aspectRatio = this.$container.attr('data-aspect-ratio');
        var featuredImage = this.$container.attr('data-img-url');
        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }
        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage
        };
        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
      },
      stringOverrides: function () {
        theme.productStrings = theme.productStrings || {};
        $.extend(theme.strings, theme.productStrings);
      },
      initVariants: function () {
        if (!document.getElementById(this.selectors.variantsJson)) {
          return;
        }
        this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);
        var options = {
          $container: this.$container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };
        if ($(this.selectors.variantColorSwatch).length) {
          $(this.selectors.variantColorSwatch).on('change', function (evt) {
            var $el = $(evt.currentTarget);
            var color = $el.data('color-name');
            var index = $el.data('color-index');
            this.updateColorName(color, index);
          }.bind(this));
        }
        this.variants = new theme.Variants(options);
        this.$container
          .on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this))
          .on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this))
          .on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this))
          .on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));
        if ($(this.selectors.sku).length) {
          this.$container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
        if (this.settings.inventory || this.settings.incomingInventory) {
          this.$container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable && document.getElementById(this.selectors.currentVariantJson)) {
          this.currentVariantObject = JSON.parse(document.getElementById(this.selectors.currentVariantJson).innerHTML);
          this.$variantSelectors.on('change' + this.settings.namespace, this.updateVariantAvailability.bind(this));
          // Set default state based on current selected variant
          this.setCurrentVariantAvailability(this.currentVariantObject, true);
        }
      },
      initQtySelector: function () {
        this.$container.find('.js-qty__wrapper').each(function () {
          new theme.QtySelector($(this), {
            namespace: '.product'
          });
        });
      },
      initAjaxProductForm: function () {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct($(this.selectors.formContainer));
        }
      },
      setCurrentVariantAvailability: function (variant) {
        var valuesToEnable = {
          option1: [],
          option2: [],
          option3: []
        };
        // Disable all options to start
        this.disableVariantGroup($(this.selectors.formContainer).find('.variant-input-wrap'));
        // Combine all available variants
        var availableVariants = this.variantsObject.filter(function (el) {
          if (variant.id === el.id) {
            return false;
          }
          // Option 1
          if (variant.option2 === el.option2 && variant.option3 === el.option3) {
            return true;
          }
          // Option 2
          if (variant.option1 === el.option1 && variant.option3 === el.option3) {
            return true;
          }
          // Option 3
          if (variant.option1 === el.option1 && variant.option2 === el.option2) {
            return true;
          }
        });
        // IE11 can't handle shortform of {variant} so extra step is needed
        var variantObject = {
          variant: variant
        };
        availableVariants = Object.assign({}, variantObject, availableVariants);
        // Loop through each available variant to gather variant values
        for (var property in availableVariants) {
          if (availableVariants.hasOwnProperty(property)) {
            var item = availableVariants[property];
            var option1 = item.option1;
            var option2 = item.option2;
            var option3 = item.option3;
            if (option1) {
              if (valuesToEnable.option1.indexOf(option1) === -1) {
                valuesToEnable.option1.push(option1);
              }
            }
            if (option2) {
              if (valuesToEnable.option2.indexOf(option2) === -1) {
                valuesToEnable.option2.push(option2);
              }
            }
            if (option3) {
              if (valuesToEnable.option3.indexOf(option3) === -1) {
                valuesToEnable.option3.push(option3);
              }
            }
          }
        }
        // Have values to enable, separated by option index
        if (valuesToEnable.option1.length) {
          this.enableVariantOptionByValue(valuesToEnable.option1, 'option1');
        }
        if (valuesToEnable.option2.length) {
          this.enableVariantOptionByValue(valuesToEnable.option2, 'option2');
        }
        if (valuesToEnable.option3.length) {
          this.enableVariantOptionByValue(valuesToEnable.option3, 'option3');
        }
      },
      updateVariantAvailability: function (evt, value, index) {
        if (value && index) {
          var newVal = value;
          var optionIndex = index;
        } else {
          var $el = $(evt.currentTarget);
          var newVal = $el.val() ? $el.val() : evt.currentTarget.value;
          var optionIndex = $el.data('index');
        }
        var variants = this.variantsObject.filter(function (el) {
          return el[optionIndex] === newVal;
        });
        // Disable all buttons/dropdown options that aren't the current index
        $(this.selectors.formContainer).find('.variant-input-wrap').each(function (index, el) {
          var $group = $(el);
          var currentOptionIndex = $group.data('index');
          if (currentOptionIndex !== optionIndex) {
            // Disable all options as a starting point
            this.disableVariantGroup($group);
            // Loop through legit available options and enable
            for (var i = 0; i < variants.length; i++) {
              this.enableVariantOption($group, variants[i][currentOptionIndex]);
            }
          }
        }.bind(this));
      },
      disableVariantGroup: function ($group) {
        if (theme.settings.dynamicVariantType === 'dropdown') {
          $group.find('option').prop('disabled', true)
        } else {
          $group.find('input').prop('disabled', true);
          $group.find('label').toggleClass('disabled', true);
        }
      },
      enableVariantOptionByValue: function (array, index) {
        var $group = $(this.selectors.formContainer).find('.variant-input-wrap[data-index="' + index + '"]');
        for (var i = 0; i < array.length; i++) {
          this.enableVariantOption($group, array[i]);
        }
      },
      enableVariantOption: function ($group, value) {
        // Selecting by value so escape it
        value = value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
        if (theme.settings.dynamicVariantType === 'dropdown') {
          $group.find('option[value="' + value + '"]').prop('disabled', false);
        } else {
          var $buttonGroup = $group.find('.variant-input[data-value="' + value + '"]');
          $buttonGroup.find('input').prop('disabled', false);
          $buttonGroup.find('label').toggleClass('disabled', false);
        }
      },
      updateColorName: function (color, index) {
        // Updates on radio button change, not variant.js
        $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
      },
      updateCartButton: function (evt) {
        var variant = evt.variant;
        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            $(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled', false);
            var defaultText = $(this.selectors.addToCartText).data('default-text');
            $(this.selectors.addToCartText).html(defaultText);
          } else {
            // Sold out, disable the submit button and change text
            $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
            $(this.selectors.addToCartText).html(theme.strings.soldOut);
          }
        } else {
          // The variant doesn't exist, disable submit button
          $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.unavailable);
        }
      },
      updatePrice: function (evt) {
        var variant = evt.variant;
        if (variant) {
          // Regular price
          $(this.selectors.price).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();
          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
            $(this.selectors.priceWrapper).removeClass('hide');
            $(this.selectors.price).addClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
            $(this.selectors.priceA11y).attr('aria-hidden', 'false');
            var savings = variant.compare_at_price - variant.price;
            if (theme.settings.saveType == 'percent') {
              savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
            } else {
              savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            }
            $(this.selectors.savePrice)
              .removeClass('hide')
              .html(theme.strings.savePrice.replace('[saved_amount]', savings));
          } else {
            $(this.selectors.priceWrapper).addClass('hide');
            $(this.selectors.price).removeClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
            $(this.selectors.priceA11y).attr('aria-hidden', 'true');
            $(this.selectors.savePrice).addClass('hide')
          }
        }
      },
      updateUnitPrice: function (evt) {
        var variant = evt.variant;
        if (variant && variant.unit_price) {
          $(this.selectors.unitPrice).html(theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat));
          $(this.selectors.unitPriceBaseUnit).text(theme.Currency.getBaseUnit(variant));
          $(this.selectors.unitWrapper).removeClass('hide').removeClass(classes.visuallyHide);
        } else {
          $(this.selectors.unitWrapper).addClass(classes.visuallyHide);
        }
      },
      updateSku: function (evt) {
        var variant = evt.variant;
        var newSku = '';
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
          $(this.selectors.sku).html(newSku);
        }
      },
      updateInventory: function (evt) {
        var variant = evt.variant;
        // Hide stock if no inventory management or policy is continue
        if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') {
          this.toggleInventoryQuantity(false);
          this.toggleIncomingInventory(false);
          return;
        }
        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.sectionId]) {
          variantInventoryObject = window.inventories[this.sectionId][variant.id];
          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;
          if (quantity <= 0 || quantity > theme.settings.inventoryThreshold) {
            showInventory = false;
          }
          this.toggleInventoryQuantity(showInventory, quantity);
          if (!showInventory && variantInventoryObject.incoming) {
            showIncomingInventory = true;
          }
          this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
        }
      },
      toggleInventoryQuantity: function (show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }
        if (show) {
          $(this.selectors.inventory)
            .removeClass('hide')
            .text(theme.strings.stockLabel.replace('[count]', qty));
        } else {
          $(this.selectors.inventory).addClass('hide');
        }
      },
      toggleIncomingInventory: function (show, available, date) {
        if (!this.settings.incomingInventory) {
          show = false;
        }
        if (show) {
          var string = available ?
            theme.strings.willNotShipUntil.replace('[date]', date) :
            theme.strings.willBeInStockAfter.replace('[date]', date);
          if (!date) {
            string = theme.strings.waitingForStock;
          }
          $(this.selectors.incomingInventory)
            .removeClass('hide')
            .text(string);
        } else {
          $(this.selectors.incomingInventory).addClass('hide');
        }
      },
      checkIfVideos: function () {
        var $productVideos = this.$mainSlider.find(selectors.productVideo);
        // Stop if there are 0 videos
        if (!$productVideos.length) {
          return false;
        }
        var videoTypes = [];
        $productVideos.each(function () {
          var type = $(this).data('video-type');
          if (videoTypes.indexOf(type) < 0) {
            videoTypes.push(type);
          }
        });
        // Load YouTube API if not already loaded
        if (videoTypes.indexOf('youtube') > -1) {
          if (!theme.config.youTubeReady) {
            theme.LibraryLoader.load('youtubeSdk');
            $('body').on('youTubeReady' + this.settings.namespace, function () {
              this.loadYoutubeVideos($productVideos);
            }.bind(this));
          } else {
            this.loadYoutubeVideos($productVideos);
          }
        }
        // Add mp4 video players
        if (videoTypes.indexOf('mp4') > -1) {
          this.loadMp4Videos($productVideos);
        }
        return videoTypes;
      },
      loadMp4Videos: function ($videos) {
        $videos.each(function () {
          var $el = $(this);
          if ($el.data('video-type') != 'mp4') {
            return;
          }
          var id = $el.attr('id');
          var videoId = $el.data('video-id');
          videos[id] = {
            type: 'mp4',
            divId: id,
            style: $el.data('video-style')
          };
        });
      },
      loadYoutubeVideos: function ($videos) {
        $videos.each(function () {
          var $el = $(this);
          if ($el.data('video-type') != 'youtube') {
            return;
          }
          var id = $el.attr('id');
          var videoId = $el.data('youtube-id');
          videos[id] = {
            type: 'youtube',
            id: id,
            videoId: videoId,
            style: $el.data('video-style'),
            loop: $el.data('video-loop'),
            attemptedToPlay: false,
            events: {
              onReady: function (evt) {
                onVideoPlayerReady(evt, id);
              },
              onStateChange: function (evt) {
                onVideoStateChange(evt, id);
              }
            }
          };
        });
        // Create a player for each YouTube video
        for (var key in videos) {
          if (videos[key].type === 'youtube') {
            if (videos.hasOwnProperty(key)) {
              var args = $.extend({}, youtubeVideoOptions, videos[key]);
              if (args.style === 'muted') {
                // default youtubeVideoOptions, no need to change anything
              } else {
                args.playerVars.controls = 1;
                args.playerVars.autoplay = 0;
              }
              youtubePlayers[key] = new YT.Player(key, args);
            }
          }
        }
        youtubeReady = true;
      },
      initVideo: function ($video) {
        var videoType = $video.data('video-type');
        var divId = $video.attr('id');
        if (videoType === 'mp4' && videos[divId].style === 'muted') {
          this.playMp4Video(divId);
        }
        if (videoType === 'youtube') {
          if (youtubeReady && videos[divId].style === 'muted') {
            this.requestToPlayYoutubeVideo(divId);
          }
        }
        // Hacky way to trigger resetting the slider layout in modals
        if (this.inModal) {
          this.resizeSlides();
        }
      },
      stopVideo: function (id, type) {
        if (!id) {
          this.stopYoutubeVideo();
          this.stopMp4Video();
        }
        if (type === 'youtube') {
          this.stopYoutubeVideo(id);
        }
        if (type === 'mp4') {
          this.stopMp4Video(id);
        }
      },
      getVideoType: function ($video) {
        return $video.data('video-type');
      },
      getVideoId: function ($video) {
        return $video.attr('id');
      },
      // Sub video functions (MP4 and YouTube)
      requestToPlayYoutubeVideo: function (id, forcePlay) {
        if (!theme.config.youTubeReady) {
          return;
        }
        var $player = $('#' + id);
        setParentAsLoading($player);
        // If video is requested too soon, player might not be ready.
        // Set arbitrary timeout to request it again in a second
        if (typeof youtubePlayers[id].playVideo != 'function') {
          setTimeout(function () {
            this.playYoutubeVideo(id, forcePlay);
          }.bind(this), 1000);
          return;
        }
        this.playYoutubeVideo(id, forcePlay);
      },
      playYoutubeVideo: function (id, forcePlay) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
        if (typeof youtubePlayers[id].playVideo === 'function') {
          youtubePlayers[id].playVideo();
        }
        // forcePlay is sent as true from beforeSlideChange so the visibility
        // check isn't fooled by the next slide positioning
        if (!forcePlay) {
          initCheckVisibility(id);
        }
      },
      stopYoutubeVideo: function (id) {
        if (!theme.config.youTubeReady) {
          return;
        }
        if (id && youtubePlayers[id]) {
          if (typeof youtubePlayers[id].pauseVideo === 'function') {
            youtubePlayers[id].pauseVideo();
          }
          $(window).off('scroll.' + id);
        } else {
          for (key in youtubePlayers) {
            var childVideo = this.$container.find('#' + key);
            if (childVideo.length && typeof youtubePlayers[key].pauseVideo === 'function') {
              youtubePlayers[key].pauseVideo();
              $(window).off('scroll.' + key);
            }
          }
        }
      },
      playMp4Video: function (id) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
        var playPromise = $player[0].play();
        if (playPromise !== undefined) {
          playPromise.then(function () {})
            .catch(function (error) {
              // Likely low power mode on iOS, show controls
              $player[0].setAttribute('controls', '');
              $player.closest(selectors.videoParent).attr('data-video-style', 'unmuted');
            });
        }
      },
      stopMp4Video: function (id) {
        if (id) {
          $('#' + id)[0].pause();
        } else {
          // loop through all mp4 videos to stop them
          for (var key in videos) {
            var childVideo = this.$container.find('#' + key);
            if (childVideo.length && videos[key].type === 'mp4') {
              var player = $('#' + videos[key].divId)[0];
              if (player && typeof player.pause === 'function') {
                player.pause();
              }
            }
          }
        }
      },
      initImageZoom: function () {
        var $container = $(this.selectors.imageContainer, this.$container);
        var imageZoom = new theme.Photoswipe($container[0], this.sectionId);
      },
      setImageSizes: function () {
        if (!this.settings.hasImages) {
          return;
        }
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.$firstProductImage[0].currentSrc;
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },
      updateVariantImage: function (evt) {
        var variant = evt.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
        var $newImage = $('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));
        // No image, bail
        if (typeof imageIndex === 'undefined') {
          return;
        }
        this.$mainSlider.slick('slickGoTo', imageIndex);
      },
      initImageSwitch: function () {
        if (!$(this.selectors.photoThumbs).length) {
          return;
        }
        $(this.selectors.photoThumbs)
          .on('click', function (evt) {
            evt.preventDefault();
          })
          .on('focus', function (evt) {
            if (!this.settings.slickThumbInitialized) {
              return
            }
            var index = $(evt.currentTarget).data('index');
            if (index !== undefined) {
              this.$thumbSlider.slick('slickGoTo', index);
            }
          }.bind(this))
          .on('keydown', function (evt) {
            if (evt.keyCode === 13) {
              this.$container.find(selectors.currentSlide).focus();
            }
          }.bind(this));
      },
      createImageCarousels: function () {
        if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
          // Single product image. Init video if it exists
          var $video = $(this.selectors.productImageMain).find(selectors.productVideo);
          if ($video.length) {
            this.initVideo($video);
          }
          return;
        }
        this.settings.hasMultipleImages = true;
        this.settings.has3d = this.$container.find(this.selectors.media).length;
        // Set starting slide (for both sliders)
        var $activeSlide = this.$mainSlider.find('.starting-slide');
        var startIndex = this._slideIndex($activeSlide);
        // Lame way to prevent duplicate event listeners
        this.$mainSlider.off('init');
        this.$mainSlider.off('beforeChange');
        this.$mainSlider.on('init', this.mainSlideInit.bind(this));
        this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
        this.$thumbSlider.on('init', this.thumbSlideInit.bind(this));
        // Default (mobile) slider settings
        this.mainSliderArgs = {
          infinite: this.settings.has3d ? false : true,
          arrows: false,
          dots: true,
          adaptiveHeight: true,
          initialSlide: startIndex,
          appendDots: this.selectors.dotsContainer
        };
        this.thumbSliderArgs = {
          accessibility: false,
          initialSlide: startIndex
        };
        // Init sliders normally
        var sliderArgs = this.setSliderArgs();
        this.initSliders(sliderArgs);
        // Re-init slider when a breakpoint is hit
        $('body').on('matchSmall matchLarge', function () {
          var sliderArgs = this.setSliderArgs();
          this.initSliders(sliderArgs);
        }.bind(this));
        // Too many thumbnails can cause the AOS calculations to be off
        // so refresh that when the slider is ready
        if (AOS) {
          AOS.refresh();
        }
      },
      initSliders: function (args) {
        this.destroyImageCarousels();
        this.$mainSlider.slick(args.main);
        if (!theme.config.bpSmall) {
          this.$thumbSlider.slick(args.thumbs);
        }
        this.settings.slickMainInitialized = true;
      },
      setSliderArgs: function () {
        var args = {};
        var thumbnailsVertical = this.settings.thumbVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;
        var thumbArrows = this.settings.thumbArrows = this.$thumbSlider.data('arrows');
        var slidesToShow = thumbnailsVertical && thumbArrows ? 1 :
          (thumbnailsVertical ? 3 : 5);
        if (theme.config.bpSmall) {
          args.main = this.mainSliderArgs;
          args.thumbs = this.thumbSliderArgs;
        } else {
          args.main = $.extend({}, this.mainSliderArgs, {
            asNavFor: this.selectors.thumbSlider,
            adaptiveHeight: thumbnailsVertical ? false : true,
            dots: false,
            infinite: false,
            fade: true
          });
          args.thumbs = $.extend({}, this.thumbSliderArgs, {
            asNavFor: this.selectors.mainSlider,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: thumbArrows,
            dots: false,
            vertical: thumbnailsVertical,
            verticalSwiping: thumbnailsVertical,
            focusOnSelect: true,
            infinite: false,
            customHeightMatching: thumbArrows ? false : thumbnailsVertical,
            customSlideAdvancement: true
          });
        }
        return args;
      },
      destroyImageCarousels: function () {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('unslick');
          this.settings.slickMainInitialized = false;
        }
        if (this.$thumbSlider && this.settings.slickThumbInitialized) {
          this.$thumbSlider.slick('unslick');
          this.settings.slickThumbInitialized = false;
        }
        this.settings.slickMainInitialized = false;
        this.settings.slickThumbInitialized = false;
      },
      mainSlideInit: function (event, slick) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $video = $currentSlide.find(selectors.productVideo);
        if (!$video.length) {
          return;
        }
        this.initVideo($video);
      },
      thumbSlideInit: function (event, slick) {
        this.settings.slickThumbInitialized = true;
        // Check if we need to hide the arrows
        if (this.settings.thumbArrows) {
          this.$thumbSlider.on('setPosition', this.thumbSlideArrowVisibility.bind(this));
        }
      },
      thumbSlideArrowVisibility: function (event, slick) {
        var $slider = slick.$slider;
        var $arrows = $slider.find('.slick-arrow');
        var showArrows = false;
        if (this.settings.thumbVertical) {
          var $trackHeight = $slider.find('.slick-track').height();
          if ($trackHeight >= $slider.height()) {
            showArrows = true;
          }
        } else {
          var $trackWidth = $slider.find('.slick-track').width();
          if ($trackWidth >= $slider.width()) {
            showArrows = true;
          }
        }
        if (showArrows) {
          $arrows.removeClass('hide');
        } else {
          $arrows.addClass('hide');
        }
      },
      beforeSlideChange: function (event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $prevVideo = $currentSlide.find('.product__video');
        var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
        var $nextVideo = $nextSlide.find('.product__video');
        // Pause any existing slide video
        if (currentSlide !== nextSlide && $prevVideo.length) {
          var prevVideoType = this.getVideoType($prevVideo);
          var prevVideoId = this.getVideoId($prevVideo);
          if (prevVideoId) {
            this.stopVideo(prevVideoId, prevVideoType);
          }
        }
        // Prep next slide video
        if ($nextVideo.length) {
          var nextVideoType = this.getVideoType($nextVideo);
          var nextVideoId = this.getVideoId($nextVideo);
          // Prep YouTube with a backup in case API isn't ready
          if (nextVideoId && nextVideoType === 'youtube') {
            if (youtubeReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            } else {
              $('body').on('youTubeReady' + this.settings.namespace, function () {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.requestToPlayYoutubeVideo(nextVideoId, true);
                }
              }.bind(this))
            }
          }
          // Autoplay muted MP4 videos
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
            if (nextVideoType === 'mp4') {
              this.playMp4Video(nextVideoId);
            }
          }
          // Set unmuted videos to loaded state
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
            setParentAsLoaded($('#' + nextVideoId));
          }
        }
        // Pause any existing media
        var $currentMedia = $currentSlide.find(this.selectors.media);
        if ($currentMedia.length) {
          $currentMedia.trigger('mediaHidden');
        }
        // Prep next slide media
        var $nextMedia = $nextSlide.find(this.selectors.media);
        if ($nextMedia.length) {
          $nextMedia.trigger('mediaVisible');
          $nextSlide.find('.shopify-model-viewer-ui__button').attr('tabindex', 0);
          $nextSlide.find('.product-single__close-media').attr('tabindex', 0);
        }
      },
      resizeSlides: function () {
        if (!this.settings.hasMultipleImages) {
          return;
        }
        $(window).trigger('resize.slick');
        setTimeout(function () {
          if (this.$mainSlider && this.settings.slickMainInitialized) {
            this.$mainSlider.slick('setPosition');
          }
          if (this.$thumbSlider && this.settings.slickThumbInitialized) {
            this.$thumbSlider.slick('setPosition');
          }
        }.bind(this), 500); // same timing as modal open transition
      },
      _slideIndex: function ($el) {
        return $el.data('index');
      },
      openModalProduct: function () {
        if (!this.settings.modalInit) {
          var $formHolder = $(this.selectors.modalFormHolder);
          var url = $formHolder.data('url');
          var template = $formHolder.data('template');
          // If no alt template, use stripped down ajax version
          if (!template) {
            url = url + '?view=ajax';
          }
          $formHolder.load(url + ' #AddToCartForm-' + this.sectionId, function () {
            $formHolder.addClass('is-active');
            this.formSetup();
            if (Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
          }.bind(this));
          this.productSetup();
          this.loadModalContent();
          this.createImageCarousels();
          this.customMediaListners();
          this.settings.modalInit = true;
        }
        this.resizeSlides();
        // Add product id to recently viewed array
        this.addIdToRecentlyViewed();
      },
      closeModalProduct: function () {
        this.stopVideo();
        $('body').off(this.settings.namespace);
        $(window).off(this.settings.namespace);
      },
      loadModalContent: function () {
        // Load videos if they exist
        var videoTypes = this.checkIfVideos();
        // Lazyload mp4 videos
        if (videoTypes && videoTypes.indexOf('mp4') > -1) {
          this.$modal
            .find('.product__video[data-video-type="mp4"]')
            .find('.product__video-src')
            .each(function (i, video) {
              var $el = $(video);
              var src = $el.attr('src');
              var type = $el.attr('type')
              var newEl = document.createElement('source');
              newEl.src = src;
              newEl.type = type;
              $el.after(newEl);
            }.bind(this));
        }
      },
      initModelViewerLibraries: function () {
        var $modelViewerElements = $(
          this.selectors.media,
          this.$container
        );
        if ($modelViewerElements.length < 1) return;
        theme.ProductMedia.init($modelViewerElements, this.sectionId);
      },
      initShopifyXrLaunch: function () {
        var self = this;
        $(document).on('shopify_xr_launch', function () {
          var $currentMedia = $(
            self.selectors.productMediaWrapper +
            ':not(.' +
            classes.hidden +
            ')',
            self.$container
          );
          $currentMedia.trigger('xrLaunch');
        });
      },
      customMediaListners: function () {
        $('body').on('click', this.selectors.closeMedia, function () {
          this.$mainSlider
            .find(selectors.currentSlide)
            .find(this.selectors.media)
            .trigger('mediaHidden');
        }.bind(this));
        this.$container.find('model-viewer')
          .on('shopify_model_viewer_ui_toggle_play', function (evt) {
            this.mediaLoaded(evt);
          }.bind(this))
          .on('shopify_model_viewer_ui_toggle_pause', function (evt) {
            this.mediaUnloaded(evt);
          }.bind(this));
      },
      mediaLoaded: function (evt) {
        this.$container.find(this.selectors.closeMedia).removeClass('hide');
        this.toggleSliderSwiping(false);
      },
      mediaUnloaded: function (evt) {
        this.$container.find(this.selectors.closeMedia).addClass('hide');
        this.toggleSliderSwiping(true);
      },
      toggleSliderSwiping: function (enable) {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('slickSetOption', 'swipe', enable);
          this.$mainSlider.slick('slickSetOption', 'draggable', enable);
          this.$mainSlider.slick('slickSetOption', 'touchMove', enable);
          this.$mainSlider.slick('slickSetOption', 'accessibility', enable);
        }
      },
      onUnload: function () {
        this.$container.off(this.settings.namespace);
        $('body').off(this.settings.namespace);
        this.destroyImageCarousels();
        theme.ProductMedia.removeSectionModels(this.sectionId);
      }
    });
    return Product;
  })();
  theme.Recommendations = (function () {
    function Recommendations(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      this.url = $container.data('url');
      this.selectors = {
        recommendations: '#Recommendations-' + sectionId,
        placeholder: '.product-recommendations-placeholder',
        sectionClass: ' .product-recommendations',
        productResults: '.grid-product'
      };
      this.init();
    }
    Recommendations.prototype = $.extend({}, Recommendations.prototype, {
      init: function () {
        var $section = $(this.selectors.recommendations);
        if (!$section.length || $section.data('enable') === false) {
          return;
        }
        var $placeholder = $section.find(this.selectors.placeholder);
        var id = $section.data('product-id');
        var limit = $section.data('limit');
        var url = this.url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + id;
        $placeholder.load(url + this.selectors.sectionClass, function (data) {
          theme.reinitProductGridItem($section);
          this.updateVariantInventory($section);
          // If no results, hide the entire section
          if ($(data).find(this.selectors.sectionClass).find(this.selectors.productResults).length === 0) {
            $section.addClass('hide');
          }
        }.bind(this));
      },
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateVariantInventory: function ($section) {
        window.inventories = window.inventories || {};
        $section.find('.js-product-inventory-data').each(function () {
          var $el = $(this);
          var sectionId = $el.data('section-id');
          window.inventories[sectionId] = {};
          $('.js-variant-inventory-data', $el).each(function () {
            var $child = $(this);
            window.inventories[sectionId][$child.data('id')] = {
              'quantity': $child.data('quantity'),
              'incoming': $child.data('incoming'),
              'next_incoming_date': $child.data('date')
            }
          });
        });
      }
    });
    return Recommendations;
  })();
  theme.CollectionHeader = (function () {
    var selectors = {
      hero: '.collection-hero',
      parallaxContainer: '.parallax-container'
    };

    function CollectionHeader(container) {
      var $container = $(container);
      this.namespace = '.collection-header';
      var $heroImageContainer = this.$heroContainer = $container.find(selectors.hero);
      if ($heroImageContainer.length) {
        this.checkIfNeedReload();
        if ($container.data('parallax')) {
          var $parallaxContainer = $container.find(selectors.parallaxContainer);
          var args = {
            namespace: this.namespace
          };
          theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
        }
      } else {
        // Prevent 'Overlay header over collection' header setting
        // from breaking layout. Required because settings from two
        // different sections rely on each other on page load.
        theme.headerNav.disableOverlayHeader();
      }
    }
    CollectionHeader.prototype = $.extend({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function () {
        if (!Shopify.designMode) {
          return;
        }
        if (!theme.settings.overlayHeader) {
          return;
        }
        var $header = $('.header-wrapper');
        if (!$header.hasClass('is-light') && !$('.header-wrapper').hasClass('header-wrapper--sticky')) {
          location.reload();
        }
      },
      onUnload: function () {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
      }
    });
    return CollectionHeader;
  })();
  theme.CollectionSidebar = (function () {
    var drawerStyle = false;

    function CollectionSidebar(container) {
      this.$container = $(container);
      this.init();
    }
    CollectionSidebar.prototype = $.extend({}, CollectionSidebar.prototype, {
      init: function () {
        // Force close the drawer if it exists
        this.onUnload();
        drawerStyle = this.$container.data('style') === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
      },
      forceReload: function () {
        this.init();
      },
      onSelect: function () {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }
          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },
      onDeselect: function () {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },
      onUnload: function () {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      }
    });
    return CollectionSidebar;
  })();
  theme.Collection = (function () {
    var selectors = {
      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',
      sortSelect: '#SortBy'
    };
    var data = {
      sortBy: 'data-default-sortby'
    };

    function Collection(container) {
      this.container = container;
      this.sectionId = $(container).attr('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      this.init();
    }
    Collection.prototype = $.extend({}, Collection.prototype, {
      init: function () {
        // init is called on load and when tags are selected
        this.$container = $(this.container);
        var sectionId = this.sectionId = this.$container.attr('data-section-id');
        this.namespace = '.collection-' + sectionId;
        this.$sortSelect = $(selectors.sortSelect);
        this.$sortSelect.on('change', this.onSortChange.bind(this));
        this.defaultSort = this.getDefaultSortValue();
        this.initParams();
        this.colorSwatchHovering();
        theme.reinitSection('collection-sidebar');
      },
      initParams: function () {
        this.queryParams = {};
        if (location.search.length) {
          var aKeyValue;
          var aCouples = location.search.substr(1).split('&');
          for (var i = 0; i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
              this.queryParams[
                decodeURIComponent(aKeyValue[0])
              ] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
      },
      getSortValue: function () {
        return this.$sortSelect.val() || this.defaultSort;
      },
      getDefaultSortValue: function () {
        return this.$sortSelect.attr(data.sortBy);
      },
      onSortChange: function () {
        this.queryParams.sort_by = this.getSortValue();
        if (this.queryParams.page) {
          delete this.queryParams.page;
        }
        window.location.search = $.param(this.queryParams);
      },
      colorSwatchHovering: function () {
        var $colorImage = $(selectors.colorSwatchImage);
        if (!$colorImage.length) {
          return;
        }
        $(selectors.colorSwatch).on({
          mouseenter: function (evt) {
            $el = $(evt.currentTarget);
            var id = $el.data('variant-id');
            var image = $el.data('variant-image');
            $('.grid-product__color-image--' + id)
              .css('background-image', 'url(' + image + ')')
              .addClass('is-active');
          },
          mouseleave: function (evt) {
            $el = $(evt.currentTarget);
            var id = $el.data('variant-id');
            $('.grid-product__color-image--' + id).removeClass('is-active');
          }
        });
      },
      forceReload: function () {
        this.onUnload();
        this.init();
      },
      onUnload: function () {
        $(window).off(this.namespace);
        this.$container.off(this.namespace);
        $(selectors.colorSwatch).off(this.namespace);
      }
    });
    return Collection;
  })();
  theme.HeaderSection = (function () {
    var selectors = {
      drawer: '#NavDrawer',
      mobileSubNavToggle: '.mobile-nav__toggle-btn',
      hasSublist: '.mobile-nav__has-sublist',
      disclosureLocale: '[data-disclosure-locale]',
      disclosureCurrency: '[data-disclosure-currency]'
    };
    var classes = {
      navExpanded: 'mobile-nav--expanded'
    };

    function Header(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      // Reload any slideshow if when the header is reloaded to make sure the
      // sticky header works as expected
      theme.reinitSection('slideshow-section');
      this.initDrawers();
      theme.headerNav.init();
      theme.announcementBar.init();
      this.cache = {};
      this.cacheSelectors();
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure = new theme.Disclosure(
          this.cache.$localeDisclosure
        );
      }
      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure = new theme.Disclosure(
          this.cache.$currencyDisclosure
        );
      }
      // Set a timer to resize the header in case the logo changes size
      if (Shopify.designMode) {
        setTimeout(function () {
          $('body').trigger('resize');
        }, 500);
      }
    }
    Header.prototype = $.extend({}, Header.prototype, {
      cacheSelectors: function () {
        this.cache = {
          $localeDisclosure: this.$container.find(selectors.disclosureLocale),
          $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
        };
      },
      initDrawers: function () {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        if (theme.settings.cartType === 'drawer') {
          new theme.CartDrawer();
        }
        this.drawerMenuButtons();
      },
      drawerMenuButtons: function () {
        $(selectors.drawer).find('.js-drawer-close').on('click', function (evt) {
          evt.preventDefault();
          theme.NavDrawer.close();
        });
        var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);
        $mobileSubNavToggle.attr('aria-expanded', 'false');
        $mobileSubNavToggle.each(function (i, el) {
          var $el = $(el);
          $el.attr('aria-controls', $el.attr('data-aria-controls'));
        });
        $mobileSubNavToggle.on('click', function () {
          var $el = $(this);
          var currentlyExpanded = $el.attr('aria-expanded');
          var toggleState = false;
          // Updated aria-expanded value based on state pre-click
          if (currentlyExpanded === 'true') {
            $el.attr('aria-expanded', 'false');
          } else {
            $el.attr('aria-expanded', 'true');
            toggleState = true;
          }
          // Toggle class that expands/collapses sublist
          $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
        });
      },
      onBlockSelect: function (evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },
      onDeselect: function () {
        theme.announcementBar.onBlockDeselect();
      },
      onUnload: function () {
        theme.NavDrawer.close();
        theme.headerNav.unload();
        theme.announcementBar.unload();
        if (this.cache.$localeDisclosure.length) {
          this.localeDisclosure.unload();
        }
        if (this.cache.$currencyDisclosure.length) {
          this.currencyDisclosure.unload();
        }
      }
    });
    return Header;
  })();
  theme.FooterSection = (function () {
    var selectors = {
      disclosureLocale: '[data-disclosure-locale]',
      disclosureCurrency: '[data-disclosure-currency]'
    };

    function Footer(container) {
      var $container = this.$container = $(container);
      this.cache = {};
      this.cacheSelectors();
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure = new theme.Disclosure(
          this.cache.$localeDisclosure
        );
      }
      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure = new theme.Disclosure(
          this.cache.$currencyDisclosure
        );
      }
    }
    Footer.prototype = $.extend({}, Footer.prototype, {
      cacheSelectors: function () {
        this.cache = {
          $localeDisclosure: this.$container.find(selectors.disclosureLocale),
          $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
        };
      },
      onUnload: function () {
        if (this.cache.$localeDisclosure.length) {
          this.localeDisclosure.unload();
        }
        if (this.cache.$currencyDisclosure.length) {
          this.currencyDisclosure.unload();
        }
      }
    });
    return Footer;
  })();
  theme.FeaturedContentSection = (function () {
    function FeaturedContent() {
      $('.rte').find('a:not(:has(img))').addClass('text-link');
    }
    return FeaturedContent;
  })();
  theme.slideshows = {};
  theme.SlideshowSection = (function () {
    var selectors = {
      parallaxContainer: '.parallax-container'
    };

    function SlideshowSection(container) {
      var $container = this.$container = $(container);
      var $section = $container.parent();
      var sectionId = $container.attr('data-section-id');
      var slideshow = this.slideshow = '#Slideshow-' + sectionId;
      this.namespace = '.' + sectionId;
      var $imageContainer = $(container).find('.hero');
      if ($imageContainer.length) {
        theme.loadImageSection($imageContainer);
      }
      this.init();
      if ($container.data('parallax')) {
        var args = {
          namespace: this.namespace
        };
        theme.parallaxSections[this.namespace] = new theme.Parallax($container.find(selectors.parallaxContainer), args);
      }
    }
    SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
      init: function () {
        // Prevent slideshows from initializing on top of themselves
        this.onUnload();
        var $slideshow = $(this.slideshow);
        var args = {
          autoplay: $slideshow.data('autoplay'),
          arrows: $slideshow.data('arrows'),
          dots: $slideshow.data('dots'),
          fade: true,
          speed: 500 // same as $slideshowImageAnimationSpeed in CSS
        };
        theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
      },
      forceReload: function () {
        this.init();
      },
      onUnload: function () {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
        if (theme.slideshows[this.slideshow]) {
          theme.slideshows[this.slideshow].destroy();
          delete theme.slideshows[this.slideshow];
        }
      },
      onSelect: function () {
        $(this.slideshow).slick('slickPause');
      },
      onDeselect: function () {
        $(this.slideshow).slick('slickPlay');
      },
      onBlockSelect: function (evt) {
        var $slideshow = $(this.slideshow);
        // Ignore the cloned version
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
      },
      onBlockDeselect: function () {
        $(this.slideshow).slick('slickPlay');
      }
    });
    return SlideshowSection;
  })();
  theme.VideoSection = (function () {
    var youtubeReady;
    var videos = [];
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };
    var vimeoReady = false;
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };
    var selectors = {
      videoParent: '.video-parent-section',
      promoContainer: '.promo-grid__container'
    };
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    };

    function videoSection(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
      this.namespace = '.' + youtubePlayerId;
      var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
      var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
      var mp4Video = 'Mp4Video-' + this.sectionId;
      var $youtubeDiv = $('#' + youtubePlayerId);
      var $vimeoDiv = $('#' + vimeoPlayerId);
      var $mp4Div = $('#' + mp4Video);
      this.vimeoPlayer = [];
      if ($youtubeDiv.length) {
        this.youtubeVideoId = $youtubeDiv.data('video-id');
        this.initYoutubeVideo();
      }
      if ($vimeoDiv.length) {
        this.vimeoVideoId = $vimeoDiv.data('video-id');
        this.initVimeoVideo();
      }
      if ($mp4Div.length) {
        setParentAsLoaded($mp4Div);
        startMp4Playback(mp4Video).then(function () {
          // Video played as expected, don't do anything
        }).catch(function (error) {
          // Video cannot be played with autoplay, so let
          // user interact with video element itself
          $mp4Div.attr('controls', '');
          setVideoToBeInteractedWith($mp4Div);
        })
      }
    }

    function startMp4Playback(mp4Video) {
      return document.querySelector('#' + mp4Video).play();
    }

    function onVideoPlayerReady(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
      setParentAsLoading($player);
      youtubePlayers[playerId].mute();
      // Remove from tabindex because YouTube iframes are annoying and you can focus
      // on the YouTube logo and it breaks
      $player.attr('tabindex', '-1');
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {
        id: playerId
      }, $.throttle(150, videoVisibilityCheck));
    }

    function videoVisibilityCheck(id) {
      var playerId;
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        playerId = id.data ? id.data.id : false;
      }
      if (playerId) {
        if (theme.isElementVisible($('#' + playerId))) {
          playVisibleVideo(playerId);
        } else {
          pauseHiddenVideo(playerId);
        }
      }
    }

    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }

    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }

    function onVideoStateChange(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }

    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }

    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }

    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
      $el
        .closest(selectors.promoContainer)
        .addClass(classes.interactable);
    }
    videoSection.prototype = $.extend({}, videoSection.prototype, {
      initYoutubeVideo: function () {
        videos[this.youtubePlayerId] = {
          id: this.youtubePlayerId,
          videoId: this.youtubeVideoId,
          type: 'youtube',
          attemptedToPlay: false,
          events: {
            onReady: function (evt) {
              onVideoPlayerReady(evt, this.youtubePlayerId);
            }.bind(this),
            onStateChange: function (evt) {
              onVideoStateChange(evt, this.youtubePlayerId);
            }.bind(this)
          }
        };
        if (!youtubeReady) {
          theme.LibraryLoader.load('youtubeSdk');
          $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
        } else {
          this.loadYoutubeVideo();
        }
      },
      loadYoutubeVideo: function () {
        var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
        args.playerVars.controls = 0;
        youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);
        youtubeReady = true;
      },
      initVimeoVideo: function () {
        videos[this.vimeoPlayerId] = {
          divId: this.vimeoPlayerId,
          id: this.vimeoVideoId,
          type: 'vimeo'
        };
        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoading($player);
        // Button to play video on mobile
        this.$vimeoTrigger.on('click', +this.namespace, function (evt) {
          // $(evt.currentTarget).addClass('hide');
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        }.bind(this));
        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
        } else {
          this.loadVimeoVideo();
        }
      },
      loadVimeoVideo: function () {
        var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
        this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);
        vimeoReady = true;
        // Only autoplay on larger screens
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        } else {
          var $player = $('#' + this.vimeoPlayerId);
          setParentAsLoaded($player);
        }
      },
      requestToPlayVimeoVideo: function (id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.
        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.namespace, function () {
            this.playVimeoVideo(id);
          }.bind(this))
          return;
        }
        this.playVimeoVideo(id);
      },
      playVimeoVideo: function (id) {
        this.vimeoPlayer[id].play();
        this.vimeoPlayer[id].setVolume(0);
        var $player = $('#' + id);
        setParentAsLoaded($player);
      },
      onUnload: function (evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        var playerId = 'YouTubeVideo-' + sectionId;
        youtubePlayers[playerId].destroy();
        $(window).off('scroll' + this.namespace);
        $('body').off('vimeoReady' + this.namespace);
      }
    });
    return videoSection;
  })();
  theme.BackgroundImage = (function () {
    var selectors = {
      parallaxContainer: '.parallax-container'
    };

    function backgroundImage(container) {
      var $container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.namespace = '.' + sectionId;
      if (!$container.length) {
        return;
      }
      if ($container.data('parallax')) {
        var $parallaxContainer = $container.find(selectors.parallaxContainer);
        var args = {
          namespace: this.namespace,
          desktopOnly: true
        };
        theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
      }
    }
    backgroundImage.prototype = $.extend({}, backgroundImage.prototype, {
      onUnload: function (evt) {
        theme.parallaxSections[this.namespace].destroy();
        delete theme.parallaxSections[this.namespace];
      }
    });
    return backgroundImage;
  })();
  theme.Testimonials = (function () {
    var slideCount = 0;
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: true,
      autoplay: false,
      touchThreshold: 20,
      slidesToShow: 3,
      slidesToScroll: 3
    };

    function Testimonials(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var wrapper = this.wrapper = '.testimonials-wrapper';
      var slider = this.slider = '#Testimonials-' + sectionId;
      var $slider = $(slider);
      this.sliderActive = false;
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      });
      slideCount = $slider.data('count');
      // Override slidesToShow/Scroll if there are not enough blocks
      if (slideCount < defaults.slidesToShow) {
        defaults.slidesToShow = slideCount;
        defaults.slidesToScroll = slideCount;
      }
      $slider.on('init', this.a11y.bind(this));
      if (theme.config.bpSmall) {
        this.init($slider, mobileOptions);
      } else {
        this.init($slider, defaults);
      }
      $('body').on('matchSmall', function () {
        this.init($slider, mobileOptions);
      }.bind(this));
      $('body').on('matchLarge', function () {
        this.init($slider, defaults);
      }.bind(this));
    }
    Testimonials.prototype = $.extend({}, Testimonials.prototype, {
      onUnload: function () {
        $(this.slider, this.wrapper).slick('unslick');
      },
      onBlockSelect: function (evt) {
        // Ignore the cloned version
        var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
        // Go to selected slide, pause autoplay
        $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
      },
      init: function (obj, args) {
        if (this.sliderActive) {
          obj.slick('unslick');
          this.sliderActive = false;
        }
        obj.slick(args);
        this.sliderActive = true;
        if (AOS) {
          AOS.refresh();
        }
      },
      a11y: function (event, obj) {
        var $list = obj.$list;
        var $wrapper = $(this.wrapper, this.$container);
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
        // When an element in the slider is focused set aria-live
        $wrapper.on('focusin', function (evt) {
          if ($wrapper.has(evt.target).length) {
            $list.attr('aria-live', 'polite');
          }
        });
        // Remove aria-live
        $wrapper.on('focusout', function (evt) {
          if ($wrapper.has(evt.target).length) {
            $list.removeAttr('aria-live');
          }
        });
      }
    });
    return Testimonials;
  })();
  theme.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.cookieName = 'newsletter-' + sectionId;
      if (!$container.length) {
        return;
      }
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
      this.data = {
        secondsBeforeShow: $container.data('delay-seconds'),
        daysBeforeReappear: $container.data('delay-days'),
        cookie: Cookies.get(this.cookieName),
        testMode: $container.data('test-mode')
      };
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
      // Open modal if errors or success message exist
      if ($container.find('.errors').length || $container.find('.note--success').length) {
        this.modal.open();
      }
      // Set cookie as opened if success message
      if ($container.find('.note--success').length) {
        this.closePopup(true);
        return;
      }
      $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));
      if (!this.data.cookie || this.data.testMode) {
        this.initPopupDelay();
      }
    }
    NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        setTimeout(function () {
          this.modal.open();
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode) {
          Cookies.remove(this.cookieName, {
            path: '/'
          });
          return;
        }
        var expiry = success ? 200 : this.data.daysBeforeReappear;
        Cookies.set(this.cookieName, 'opened', {
          path: '/',
          expires: expiry
        });
      },
      onLoad: function () {
        this.modal.open();
      },
      onSelect: function () {
        this.modal.open();
      },
      onDeselect: function () {
        this.modal.close();
      },
      onUnload: function () {}
    });
    return NewsletterPopup;
  })();
  theme.Maps = (function () {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
    var errors = {
      addressNoResults: theme.strings.addressNoResults,
      addressQueryLimit: theme.strings.addressQueryLimit,
      addressError: theme.strings.addressError,
      authError: theme.strings.authError
    };
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '[data-map-overlay]'
    };
    var classes = {
      mapError: 'map-section--load-error',
      errorMsg: 'map-section__error errors text-center'
    };
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function () {
      if (!Shopify.designMode) {
        return;
      }
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).after(
        '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
      );
    };

    function Map(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.$map = this.$container.find(selectors.map);
      this.key = this.$map.data('api-key');
      if (!this.key) {
        return;
      }
      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
    }

    function initAllMaps() {
      // API has loaded, load all Map instances in queue
      $.each(mapsToLoad, function (index, instance) {
        instance.createMap();
      });
    }

    function geolocate($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data('address-setting');
      geocoder.geocode({
        address: address
      }, function (results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status);
        }
        deferred.resolve(results);
      });
      return deferred;
    }
    Map.prototype = $.extend({}, Map.prototype, {
      prepMapApi: function () {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined') {
              $.getScript(
                'https://maps.googleapis.com/maps/api/js?key=' + this.key
              ).then(function () {
                apiStatus = 'loaded';
                initAllMaps();
              });
            }
          }
        }
      },
      createMap: function () {
        var $map = this.$map;
        return geolocate($map)
          .then(
            function (results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
              var map = (this.map = new google.maps.Map($map[0], mapOptions));
              var center = (this.center = map.getCenter());
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
              google.maps.event.addDomListener(
                window,
                'resize',
                $.debounce(250, function () {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  $map.removeAttr('style');
                })
              );
            }.bind(this)
          )
          .fail(function () {
            var errorMessage;
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              $map
                .parent()
                .addClass(classes.mapError)
                .html(
                  '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
                );
            }
          });
      },
      checkVisibility: function () {
        if (theme.isElementVisible(this.$container, 600)) {
          this.prepMapApi();
          $(window).off(this.namespace);
        }
      },
      onUnload: function () {
        if (this.$map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        google.maps.event.clearListeners(this.map, 'resize');
      }
    });
    return Map;
  })();
  theme.Blog = (function () {
    function Blog(container) {
      this.tagFilters();
    }
    Blog.prototype = $.extend({}, Blog.prototype, {
      tagFilters: function () {
        var $filterBy = $('#BlogTagFilter');
        if (!$filterBy.length) {
          return;
        }
        $filterBy.on('change', function () {
          location.href = $(this).val();
        });
      },
      onUnload: function () {}
    });
    return Blog;
  })();
  theme.Photoswipe = (function () {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      activeImage: '.slick-active .photoswipe__image'
    };

    function Photoswipe(container, sectionId) {
      this.$container = $(container);
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.$images;
      this.inSlideshow = false;
      if (this.$container.attr('data-zoom') === 'false') {
        return;
      }
      if (this.$container.attr('data-has-slideshow') === 'true') {
        this.inSlideshow = true;
      }
      this.init();
    }
    Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
      init: function () {
        var $trigger = this.$container.find(selectors.trigger);
        this.$images = this.$container.find(selectors.images);
        var items = [];
        // Init gallery on active image
        $trigger.on('click' + this.namespace, function (evt) {
          items = this.getImageData();
          if (this.inSlideshow) {
            var index = this.$container.find(selectors.activeImage).data('index');
          } else {
            var index = $(evt.currentTarget).data('index');
          }
          this.initGallery(items, index);
        }.bind(this));
      },
      getImageData: function () {
        var haveImages = false;
        var items = [];
        var options = {};
        this.$images.each(function () {
          var haveImages = true;
          var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
          var item = {
            msrc: smallSrc,
            src: $(this).data('photoswipe-src'),
            w: $(this).data('photoswipe-width'),
            h: $(this).data('photoswipe-height'),
            el: $(this)[0],
            initialZoomLevel: 0.5
          };
          items.push(item);
        });
        return items;
      },
      initGallery: function (items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function (index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {
              x: rect.left,
              y: rect.top + pageYScroll,
              w: rect.width
            };
          }
        }
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.init();
        this.gallery.listen('afterChange', this.afterChange.bind(this));
      },
      afterChange: function () {
        if (this.inSlideshow) {
          var $slideshow = $('#ProductPhotos-' + this.sectionId);
          if ($slideshow.hasClass('slick-initialized')) {
            var newIndex = this.gallery.getCurrentIndex();
            $slideshow.slick('slickGoTo', newIndex);
          }
        }
      }
    });
    return Photoswipe;
  })();
  // Medium breakpoint is also set in theme.css.liquid and inline throughout some templates.
  // Do not change values unless you know what you're doing.
  theme.bp = {};
  theme.bp.smallUp = 769;
  theme.bp.small = theme.bp.smallUp - 1;
  theme.config = {
    bpSmall: false,
    hasSessionStorage: true,
    hasLocalStorage: true,
    mediaQuerySmall: 'screen and (max-width: ' + theme.bp.small + 'px)',
    mediaQuerySmallUp: 'screen and (min-width: ' + theme.bp.smallUp + 'px)',
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
    isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1),
    stickyHeader: false,
    recentlyViewed: []
  };
  if (theme.config.isIpad) {
    document.documentElement.className += ' js-ipad';
  }
  theme.recentlyViewed = {
    recent: {}, // will store handle+url of recent products
    productInfo: {} // will store product data to reduce API calls
  };
  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    $('body').trigger('youTubeReady');
  }
  window.loadVimeo = function () {
    if (theme.config.vimeoLoading) {
      return;
    }
    if (!theme.config.vimeoReady) {
      theme.config.vimeoLoading = true;
      var tag = document.createElement('script');
      tag.src = "https://player.vimeo.com/api/player.js";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      // Because there's no way to check for the Vimeo API being loaded
      // asynchronously, we use this terrible timeout to wait for it being ready
      checkIfVimeoIsReady()
        .then(function () {
          theme.config.vimeoReady = true;
          theme.config.vimeoLoading = false;
          $('body').trigger('vimeoReady');
        })
        .fail(function () {
          // No vimeo API to talk to
        });
    }
  }

  function checkIfVimeoIsReady() {
    var deferred = $.Deferred();
    var wait;
    var timeout;
    wait = setInterval(function () {
      if (!Vimeo) {
        return;
      }
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);
    timeout = setTimeout(function () {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds
    return deferred;
  }
  theme.init = function () {
    theme.setGlobals();
    theme.collapsibles.init();
    theme.rte.init();
    AOS.init({
      easing: 'ease-out-quad',
      once: true,
      offset: 60,
      disableMutationObserver: true
    });
    $(document.documentElement).on('keyup.tab', function (evt) {
      if (evt.keyCode === 9) {
        $(document.documentElement).addClass('tab-outline');
        $(document.documentElement).off('keyup.tab');
      }
    });
    // Change email icon to submit text
    $('.footer__newsletter-input').on('keyup', function () {
      $(this).addClass('footer__newsletter-input--active');
    });
  };
  theme.initSecondary = function () {
    theme.initQuickShop();
    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }
    theme.collectionTemplate.init();
    theme.customerTemplates.init();
    theme.videoModal();
  };
  theme.setGlobals = function () {
    theme.config.hasSessionStorage = theme.isStorageSupported('session');
    theme.config.hasLocalStorage = theme.isStorageSupported('local');
    if (theme.config.hasLocalStorage) {
      theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');
      if (theme.recentlyViewed.localStorage) {
        theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
      }
    }
    theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};
    if (theme.config.isTouch) {
      $('body').addClass('supports-touch');
    }
    enquire.register(theme.config.mediaQuerySmall, {
      match: function () {
        theme.config.bpSmall = true;
        $('body').trigger('matchSmall');
      },
      unmatch: function () {
        theme.config.bpSmall = false;
        $('body').trigger('unmatchSmall');
      }
    });
    enquire.register(theme.config.mediaQuerySmallUp, {
      match: function () {
        $('body').trigger('matchLarge');
      },
      unmatch: function () {
        $('body').trigger('unmatchLarge');
      }
    });
  };
  theme.loadImageSection = function ($container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      $container.removeClass('loading loading--delayed').addClass('loaded');
    }

    function checkForLazyloadedImage() {
      return $container.find('.lazyloaded').length;
    }
    // If it has SVGs it's in the onboarding state so set as loaded
    if ($container.find('svg').length) {
      setAsLoaded();
      return;
    };
    if (checkForLazyloadedImage() > 0) {
      setAsLoaded();
      return;
    }
    var interval = setInterval(function () {
      if (checkForLazyloadedImage() > 0) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 80);
  };
  theme.isStorageSupported = function (type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }
    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };
  theme.isElementVisible = function ($el, threshold) {
    var rect = $el[0].getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    threshold = threshold ? threshold : 0;
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (windowHeight + threshold) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  theme.reinitSection = function (section) {
    for (var i = 0; i < sections.instances.length; i++) {
      var instance = sections.instances[i];
      if (instance['type'] === section) {
        if (typeof instance.forceReload === 'function') {
          instance.forceReload();
        }
      }
    }
  };
  theme.reinitProductGridItem = function ($scope) {
    if (AOS) {
      AOS.refreshHard();
    }
    // Reload quick shop buttons
    theme.initQuickShop();
    // Refresh reviews app
    if (window.SPR) {
      SPR.initDomEls();
      SPR.loadBadges();
    }
    // Re-register product templates in quick view modals.
    // Will not double-register.
    sections.register('product-template', theme.Product, $scope);
    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };
  window.onpageshow = function (evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      $('body').removeClass('unloading');
    }
  };
  $(document).ready(function () {
    theme.init();
    window.sections = new theme.Sections();
    sections.register('header-section', theme.HeaderSection);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('video-section', theme.VideoSection);
    sections.register('background-image', theme.BackgroundImage);
    sections.register('recently-viewed', theme.RecentlyViewed);
    sections.register('product', theme.Product);
    sections.register('product-recommendations', theme.Recommendations);
    sections.register('product-template', theme.Product);
    sections.register('collection-header', theme.CollectionHeader);
    sections.register('collection-sidebar', theme.CollectionSidebar);
    sections.register('collection-template', theme.Collection);
    sections.register('featured-content-section', theme.FeaturedContentSection);
    sections.register('testimonials', theme.Testimonials);
    sections.register('newsletter-popup', theme.NewsletterPopup);
    sections.register('map', theme.Maps);
    sections.register('blog', theme.Blog);
    sections.register('photoswipe', theme.Photoswipe);
    sections.register('footer-section', theme.FooterSection);
    theme.initSecondary();
  });
})(theme.jQuery);